export default {
    "corporate": "Programma aziendale",
    "onboarding": {
        "goal_desc": "Guadagnerai %{customPoints} per aver registrato la tua attività e %{customPoints} bonus per aver completato gli obiettivi. È ora di iniziare! Puoi avere 3 obiettivi personali attivi contemporaneamente.",
        "sample_task": {
            "modalActivityTitle": "3 respiri profondi",
            "rewards_featured_title": "In primo piano",
            "rewards_partners_title": "Partner",
            "header_description": "Guadagnerai %{customPoints} registrando la tua attività e completando compiti, obiettivi e sfide.",
            "icon_text": "Tocca {icon} per registrare un respiro profondo.",
            "activityName": "respirazione profonda",
            "activityUnit": "respira"
        },
        "lets_get_started": "Iniziamo!",
        "start_description": "Guadagnerai %{customPoints} registrando la tua attività e completando compiti, obiettivi e sfide.",
        "complete_and_earn": "Completa e guadagna",
        "did_it": "Ce l'ho fatta!",
        "task_complete": "Compito completato!",
        "breath_sample_task": "Un rapido tutorial sulla registrazione dell'attività",
        "track_a_sample_activity": "Registra un'attività di prova",
        "nice": "Bello!",
        "nice_one": "Bella questa!",
        "nice_subtext_1": "Hai guadagnato %{points} %{customPoints}.",
        "nice_subtext_2": "Guadagnare %{customPoints} ti aiuterà a salire di livello. Ogni volta che sali di livello, guadagnerai %{reward_currency}, che può essere riscattata per ricevere fantastiche offerte.",
        "nice_subtext_3": "Guadagnerai più punti quando completerai più attività, registrerai l'attività e completerai obiettivi e sfide.",
        "progress_subtitle": "I tuoi %{customPoints} e i progressi si azzerano ogni %{frequency}.",
        "skip_for_now": "Salta per ora",
        "loadingText": "Resta in attesa mentre calcoliamo il tuo punteggio Benessere.",
        "goal_title": "Fissa un obiettivo personalizzato",
        "swipe_for_more": "Scorri per vedere di più",
        "skip_goals": "Per ora ho smesso di fissare obiettivi.",
        "complete_profile": "",
        "level": "Livello",
        "finish_onboarding_action": "Completa prima la fase di reclutamento",
        "vital_stats": {
            "height_ft": "Altezza piedi",
            "height_in": "Altezza pollici"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "La tua privacy è importante"
        },
        "levels": {
            "title": "Traguardi e premi",
            "tableTitle": "Traguardo"
        },
        "initialScreen": {
            "title": "Benvenuto a %{programName}, %{username}!",
            "getRewarded": "Ricevi premi con %{rewardName}",
            "completeAgainst": "Competi con i tuoi colleghi",
            "earnPoints": "Guadagna punti con le attività legate al benessere",
            "levelUp": "Sali di livello e sblocca i badge"
        },
        "starterGoals": {
            "title": "Scegli un obiettivo",
            "subtitle": "Inizia il tuo percorso di benessere con una nuova sana abitudine."
        }
    },
    "healthkit_not_available": "Impossibile connettersi con Apple Salute. Nell'app Salute, alla voce Fonti, assicurati di aver abilitato almeno l'autorizzazione ai passi e di aver registrato almeno 1 passo.",
    "changeCover": "Cambia foto",
    "joiningCommunityToast": {
        "success": {
            "message": "Sei entrato a far parte di %{name}",
            "title": "Entra nella community"
        }
    },
    "achievement_starts_date": "Inizia: %{date}",
    "editChallenge": "Modifica %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Scegli fino a 5 attività",
            "title": "Cosa ti piacerebbe fare?",
            "noActivityTitle": "Aggiunta attività in corso",
            "noActivityMessage": "Seleziona almeno un'attività o una categoria.",
            "categoryItemDescription": "Tutte le attività della categoria %{category}",
            "addActivityTitle": "Quante %{units} di %{activity} vuoi fare per %{period}?",
            "addCategoryQuantityTitle": "Quanti%{customPoints} vuoi guadagnare nella categoria %{category}?",
            "subtitleCategories": "Seleziona una categoria. Tutte le attività di questa categoria contribuiranno al raggiungimento dell'obiettivo.",
            "subtitleWithActivities": "%{num} di %{max} attività selezionate",
            "selectCategoryMessage": "Tutte le attività della categoria saranno selezionate e le attività precedentemente selezionate saranno cancellate.",
            "addActivityTitleTotal": "Quante %{activity} vuoi fare in %{period}?"
        },
        "inviteDepartments": {
            "title": "Invita i\/le dipartimenti\/divisioni"
        },
        "inviteRegions": {
            "title": "Invita le regioni"
        },
        "createInvitation": {
            "selectMore": "Seleziona almeno 2 %{entity}!"
        },
        "visibility": {
            "title": "Visibilità",
            "description": "Tutti gli utenti di %{programName} possono trovare le sfide a squadre e partecipare."
        },
        "highest": {
            "name": "Il maggior numero di %{customPoints} vince",
            "description": "Nessun limite, %{customPoints} più alti si aggiudicano il 1° posto"
        },
        "compete": {
            "individual": "Competi singolarmente",
            "team": "Competi come squadra"
        },
        "unitType": {
            "title": "Scegli come completare il tuo obiettivo",
            "subtitle": "Scegli tra le attività o una categoria"
        },
        "category": {
            "name": "Tutte le attività di una categoria",
            "description": "Ad esempio, registra qualsiasi attività in \"Movimento\"",
            "title": "Scegli una categoria",
            "subtitle": "Per quale categoria intendi registrare le attività?"
        },
        "activities": {
            "name": "Attività selezionate",
            "description": "Ad es. registra attività specifiche come il ciclismo",
            "title": "Scegli le attività",
            "subtitle": "Ti consigliamo di concentrarti su un'unica attività, ma puoi aggiungerne fino a 5",
            "maxModalTitle": "Numero massimo di attività selezionate",
            "maxModalDescription": "Puoi aggiungere al massimo 5 attività. Tocca Accetta per procedere con le 5 attività che hai selezionato o Modifica per apportare cambiamenti.",
            "warningModalTitle": "Difficoltà elevata",
            "warningModalDescription": "In questo obiettivo hai indicato molte attività da completare per lasso di tempo. Sei sicuro di voler fissare un obiettivo così impegnativo?",
            "requiredPoints": "richiesto per soddisfare %{period} %{challengeType}",
            "noActivitiesModalTitle": "Aggiunta attività in corso",
            "noActivitiesModalDescription": "Seleziona almeno un'attività."
        },
        "categoryQuantity": {
            "title": "Imposta il tuo obiettivo %{customPoints}",
            "subtitle": "Quanti %{customPoints} vuoi guadagnare dalla %{category} ogni %{period}?",
            "subtitleTotal": "Quanti %{customPoints} vuoi guadagnare dalla %{category} %{period}?",
            "text": "Indicativamente, 30 minuti di attività moderata equivalgono a circa 105 %{customPoints}",
            "noQuantityModalTitle": "Quantità",
            "noQuantityModalDescription": "Immetti un valore",
            "defaultCategoryTitle": "categoria attuale"
        },
        "cancel": {
            "title": "Annulla creazione della sfida",
            "message": "Sei sicuro di voler annullare la creazione della sfida?"
        },
        "createNew": "Crea una nuova sfida",
        "chooseChallengeTitle": "Scegli una sfida o creane una tua",
        "createOwn": {
            "title": "Crea la mia"
        },
        "frequency": {
            "title": "Con quale frequenza raggiungi il tuo obiettivo?",
            "subtitle": "Gli obiettivi giornalieri sono eccellenti nella creazione delle abitudini"
        },
        "startAndDuration": {
            "title": "Scegli una data di inizio e una durata",
            "subtitle": "",
            "noFieldsTitle": "Data di inizio e durata",
            "noFieldsMessage": "Inserisci la data di inizio e la durata"
        },
        "finalize": {
            "title": "Rivedi il nuovo obiettivo",
            "subtitle": "",
            "noFieldsTitle": "Nome e istruzioni",
            "noFieldsMessage": "Inserisci il nome e le istruzioni",
            "name": "Il mio obiettivo %{frequency} %{names}",
            "instructionCategory": "Guadagna %{points} %{customPoints} %{frequency} da tutte le attività %{category}",
            "instructionActivities": "Registra %{items} %{frequency} e guadagna %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Ottieni il maggior numero di %{customPoints} da tutte le attività %{category} per vincere questa competizione.",
            "instructionCompetitionActivities": "Ottieni il maggior numero di %%{customPoints} da %{items} per vincere questa competizione",
            "namePlaceholder": "Dai un nome alla tua competizione",
            "titleChallenge": "Completa la tua sfida"
        },
        "dailyDescription": "Ad es. bere 8 bicchieri d'acqua al giorno",
        "weeklyDescription": "Ad es. camminare per 150 minuti alla settimana",
        "monthlyDescription": "Ad es. correre 150 km ogni mese",
        "totalDescription": "Ad es. andare in bicicletta per un totale di 10.000 km",
        "title": "Vuoi sfidare te stesso o gli altri?",
        "navigatorTitle": "Crea una sfida",
        "me": {
            "name": "Solo me stesso",
            "description": "Sfida te stesso con un obiettivo personale"
        },
        "others": {
            "name": "Competi con gli altri",
            "description": "Competi individualmente o come squadra"
        },
        "one": {
            "name": "Individualmente",
            "description": "Completa individualmente con altri utenti"
        },
        "team": {
            "name": "Come squadra",
            "description": "Completa come squadra con altre squadre"
        },
        "company": {
            "name": "Sfida aziendale",
            "description": "Crea una competizione speciale"
        },
        "adminItemTitle": "Come amministratore, puoi creare",
        "userOrTeamTitle": "Vuoi competere individualmente o come squadra?",
        "target": {
            "name": "Fissa un obiettivo da raggiungere",
            "description": "Sfida che ha un limite massimo"
        },
        "typeTitle": "Scegli un tipo di %{challengeType}",
        "teamSizeTitle": "Scegli un numero di partecipanti per ogni squadra",
        "teamSizeSubtitle": "I membri di una squadra devono essere minimo %{min} e massimo %{max}. I %{customPoints} della tua squadra sono la media di tutti i membri della squadra e puoi guadagnare %{customPoints} solo quando la tua squadra ha raggiunto il numero minimo di partecipanti.",
        "teamSize": {
            "noFieldsTitle": "Min e max",
            "noFieldsMessage": "Scegli il numero minimo e massimo di membri di una squadra."
        },
        "companyChallengeTitle": "Sfida aziendale",
        "companyChallengeSubtitle": "Sei un amministratore. Puoi organizzare sfide dipartimentali e di altro tipo",
        "chooseDepartmentTitle": "Scegli i\/le dipartimenti\/divisioni ai fini della competizione",
        "chooseRegionTitle": "Scegli le regioni ai fini della competizione",
        "goToChallenge": "Vai alla mia sfida",
        "additional": {
            "title": "Sfida creata",
            "subtitle": "Iniziamo! Invita gli altri a partecipare.",
            "makePublicName": "Rendila pubblica",
            "makePublicDescription": "Chiunque può aderire",
            "toDirectoryName": "Invia alla Directory della Sfida",
            "toDirectoryDescription": "Le persone possono crearne una proprio come questa",
            "inviteTitle": "Invita alla sfida",
            "titleGoal": "Obiettivo raggiunto!"
        },
        "quantityMinimum": {
            "message": "La quantità minima richiesta è %{quantity}",
            "title": "Quantità insufficiente"
        },
        "toast": {
            "success": "Il tuo %{challengeType} è stato creato."
        },
        "goToGoal": "Vai al mio obiettivo",
        "navigatorTitleGoal": "Crea un obiettivo",
        "quantityError": {
            "wholeNumber": "Deve essere un numero intero",
            "greaterThanZero": "Deve essere maggiore di 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Il tuo punteggio Benessere viene calcolato confrontando le risposte che hai fornito nel Sondaggio sul benessere con quelle di milioni di altre persone che rientrano nella tua stessa categoria di età e sesso. Il tuo punteggio mostra la tua posizione rispetto a loro. Il tuo punteggio si aggiornerà automaticamente ogni mese in base alle variazioni nel modo in cui fai movimento, mangi e ti senti inserite nell'app. Fissare costantemente degli obiettivi e intraprendere azioni positive per migliorare la tua salute può contribuire ad aumentare il tuo punteggio Benessere.",
            "excellent": "Il tuo punteggio Salute è migliore dell'85% rispetto a quello delle persone della tua età e del tuo sesso.",
            "very_good": "Il tuo punteggio Salute è migliore del 70-84% rispetto a quello delle persone della tua età e del tuo sesso.",
            "good": "Il tuo punteggio Salute è migliore del 51-69% rispetto a quello delle persone della tua età e del tuo sesso.",
            "fair": "Il tuo punteggio Salute è migliore del 31-50% rispetto a quello delle persone della tua età e del tuo sesso.",
            "poor": "Il tuo punteggio Salute è inferiore al 70% rispetto a quello delle persone della tua età e del tuo sesso. Non è mai troppo tardi per iniziare a dare priorità alla propria salute. Approfitta della nostra piattaforma per progredire nel tuo percorso verso il benessere!",
            "overall_result": "Nel complesso, il tuo punteggio Benessere è %{status}.",
            "category_result": "Nel complesso, il tuo punteggio {category} è {string}.",
            "goals": "Non puoi vincere senza obiettivi. Fissa fino a 3 obiettivi personali e seguili. Col passare del tempo, modificando il tuo stile di vita, vedrai il tuo punteggio aumentare."
        },
        "reminder": {
            "title": "È tempo di aggiornare il tuo Sondaggio sul benessere!",
            "updateAnswers": "Aggiorna le mie risposte"
        },
        "lastUpdated": "Ultimo aggiornamento %{date}",
        "scoreDescription": {
            "part1": "Il tuo punteggio è",
            "part2": "punteggio di",
            "belowAverage": "al di sotto della media",
            "aboveAverage": "superiore alla media",
            "part3": "per altri della tua età e del tuo sesso."
        },
        "improveScore": {
            "description": "Il punteggio viene calcolato in base alle tue risposte al Sondaggio sul benessere e alle attività registrate. Puoi aggiornare le tue risposte al sondaggio o fissare nuovi obiettivi da migliorare.",
            "desc1": "Il tuo punteggio non può salire molto più in alto! Per mantenere la routine interessante, sfida te stesso con obiettivi che vanno appena oltre le tue normali capacità e invita gli altri a competere con te per mantenere alta la motivazione.",
            "desc2": "Se sei pronto a salire di livello, è il momento di dare una spinta in più alla sfida. Sfida te stesso con obiettivi che vanno appena oltre le tue normali capacità e invita gli altri a competere con te per mantenere alta la motivazione.",
            "desc3": "Fissa degli obiettivi personali e crea delle sfide pubbliche per responsabilizzarti e mantenere alta la motivazione. Assicurati di scegliere obiettivi raggiungibili e tempi ridotti: noi consigliamo 1 settimana.",
            "desc4": "È importante essere attivi ogni giorno. Se non fai molto movimento nella tua routine quotidiana, inizia con piccoli obiettivi in linea con le tue capacità e i tuoi interessi. Assicurati di scegliere obiettivi raggiungibili e tempi ridotti: noi consigliamo 1 settimana."
        },
        "recommendedGoals": "Obiettivi consigliati",
        "recommendedDescription": {
            "desc1": "Imposta fino a",
            "desc2": "3 obiettivi",
            "desc3": "per concentrarti sul miglioramento del tuo benessere. Attualmente hai"
        },
        "categoryScore": "Il tuo punteggio %{category} è",
        "learnMore": "Scopri di più",
        "youAreSet": "Sei pronto!",
        "goalSetting": "Definizione degli obiettivi",
        "attention": "Punteggio %{category} non disponibile.",
        "move": {
            "error": "In base alle tue risposte, il tuo punteggio Movimento non è disponibile."
        },
        "eat": {
            "error": "Hai indicato che un operatore sanitario ti ha detto che hai il diabete di tipo 2 e che non è gestito."
        },
        "feel": {
            "error": "In base alle tue risposte, il tuo punteggio Benessere non è disponibile."
        },
        "survey": {
            "requiredField": "* questo campo è obbligatorio"
        },
        "score_info_title": "Cosa significa il mio punteggio",
        "company_average_info": "Media nella mia azienda",
        "demographic_average_info": "Media nella mia fascia demografica",
        "score": "punteggio Benessere",
        "table": {
            "what_it_means": "Cosa significa",
            "score": "Punteggio"
        },
        "updated": "Aggiornato",
        "label": {
            "excellent": "Ottima",
            "very_good": "Molto buona",
            "good": "Buona",
            "fair": "Discreta",
            "poor": "Cattiva"
        },
        "activity": {
            "eat": "Attività Mangiare 1, Attività Mangiare 2, Attività Mangiare 3",
            "move": "Attività Movimento 1, Attività Movimento 2, Attività Movimento 3",
            "feel": "Attività Benessere 1, Attività Benessere 2, Attività Benessere 3"
        },
        "score_info_screen": "Come viene calcolato il mio punteggio?",
        "details": "Dettagli",
        "activities": "Attività",
        "improveCategoryScore": "Migliora il mio punteggio %{category}",
        "meaning": {
            "heading": "Calcolo del punteggio"
        },
        "score_button": {
            "meaning": "Cosa significa questo punteggio?"
        },
        "improve": "Vedi gli obiettivi consigliati",
        "score_text": {
            "demographic": "Il punteggio medio per la tua età e il tuo sesso è",
            "company": "e il punteggio medio della tua azienda è"
        },
        "scoreHigher": "superiore alla media di",
        "scoreLower": "inferiore alla media di",
        "settedGoals": {
            "noGoals": "Non sono stati fissati obiettivi",
            "one": "1 obiettivo fissato",
            "n": "%{count} obiettivi fissati"
        },
        "yourScoreIsPoor": "Il tuo punteggio %{category} è scarso",
        "unlock": {
            "title": "Sblocca il tuo punteggio Benessere",
            "description": "Compila un breve questionario per conoscere il tuo stato di salute generale rispetto a quello di altre persone che rientrano nella tua fascia demografica."
        },
        "browseAndSet": "Puoi dare uno sguardo e fissare nuovi obiettivi dopo aver completato quelli attuali.",
        "excellent": {
            "desc1": "Uno stile di vita eccezionalmente sano",
            "desc2": "Rischio per la salute molto basso"
        },
        "veryGood": {
            "desc1": "Stile di vita molto sano",
            "desc2": "Basso rischio per la salute"
        },
        "good": {
            "desc1": "Stile di vita sano",
            "desc2": "Rischio medio per la salute"
        },
        "fair": {
            "desc1": "Stile di vita piuttosto sano",
            "desc2": "Rischio per la salute superiore alla media"
        },
        "poor": {
            "desc1": "Alto rischio per la salute",
            "desc2": "Si raccomanda una maggiore attività fisica quotidiana",
            "desc3": "È necessaria una maggiore attività fisica quotidiana"
        },
        "calculateScore": {
            "description": "Una volta completato il Sondaggio sul benessere, le tue risposte verranno analizzate utilizzando miliardi di variabili di dati provenienti da persone della tua età e del tuo sesso. Il calcolo tiene conto anche dell'attività che hai registrato in %{programName}.\n \n Il tuo punteggio Benessere si aggiorna regolarmente, affinché tu possa vederlo variare nel tempo."
        },
        "improveYourScore": "Migliorare il punteggio"
    },
    "challengerCount": "%{num} sfidanti",
    "team_name": "Nome della squadra",
    "syncingDeviceToast": {
        "danger": {
            "message": "Ops... si è verificato un problema nella sincronizzazione di %{name}. Riprova.",
            "title": "Sincronizza"
        },
        "success": {
            "title": "Sincronizza",
            "message": "Sincronizzazione di %{name} riuscita. Le tue attività ora sono aggiornate."
        }
    },
    "allCompanyMembers": "Tutti i membri dell'azienda",
    "allCompanyMembersTeam": "Tutti i membri dell'azienda (Squadra)",
    "successfullyRedeemedItemForConfirmation": "Questo articolo è stato riscattato con successo e un'e-mail di conferma è stata inviata all'indirizzo %{email}.",
    "no_all_events_placeholder": "Sembra che al momento non ci siano eventi disponibili a cui partecipare. Perché non ne crei uno tu?",
    "confirmDeleteAccount": "Conferma l'eliminazione inserendo l'indirizzo e-mail associato al tuo account",
    "deleteAccount": "Elimina l'account",
    "linkAccounts": "Gestisci gli account collegati",
    "titleSlug": {
        "icon_reward_text": "È facile per i membri idonei guadagnare più punti facendo acquisti presso i nostri partner o per una visita di controllo presso un dentista Members' Choice Advantage utilizzando la loro copertura aggiuntiva.",
        "icon_move_text": "Registrare le scelte salutari tutti i giorni, come dormire meglio o mangiare verdure, può farti guadagnare punti Vivere meglio.",
        "icon_redeem_text": "Vivere meglio premia i membri Medibank che hanno una copertura ospedaliera o aggiuntiva per essersi presi cura della propria salute.",
        "icon_phone_text": "Iscriviti e potrai riscattare premi, come carte regalo Salute e Benessere, o risparmiare sulla tua copertura sanitaria.",
        "wellness": "Benvenuto nel mondo del benessere",
        "goals": "Raggiungi i tuoi obiettivi",
        "devices": "Rimani in carreggiata",
        "challenges": "Crea sfide",
        "celebrate": "Benessere sociale",
        "habits": "Costruisci abitudini sane",
        "joinChallenge": "Partecipa alla sfida",
        "getSocial": "Fai amicizia",
        "reward": "Ricevi un premio per vivere in maniera più sana.",
        "move": "Fare movimento, mangiare e sentirsi meglio.",
        "phone": "Vivere meglio, sentirsi meglio."
    },
    "viewProgress": {
        "goal": "Visualizza i progressi dell'obiettivo",
        "challenge": "Visualizza i progressi della sfida",
        "progress": "Visualizza i progressi"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Inserire queste informazioni è facoltativo, per il tuo beneficio personale ed è confidenziale."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "Per questo evento sono disponibili %{potentialBonusPoints} bonus %{customPoints}!"
        },
        "modal": {
            "paragraph1": "Partecipando a questo evento guadagnerai bonus %{pointsName}.",
            "paragraph2": "Tutti i bonus %{pointsName} vengono assegnati al termine dell'evento. Non riceverai crediti bonus per gli eventi a cui non parteciperai."
        }
    },
    "EAP": {
        "contactInfo": "Informazioni di contatto",
        "doLater": "Lo farò più tardi",
        "tellMore": "Dimmi di più",
        "contactMe": "Contattami",
        "title": "Programma di assistenza ai dipendenti e alle famiglie",
        "reachGoal": {
            "title": "Aiuto a portata di mano",
            "description": "Il tuo Programma di assistenza ai dipendenti e alle famiglie (EFAP), fornito da %{providerName}, offre una serie di servizi di coaching sulla salute per aiutarti a raggiungere i tuoi obiettivi di benessere.\n \n Desideri che %{providerName} ti contatti per fornirti ulteriori informazioni?"
        },
        "privacyPolicy": "Informativa sulla privacy %{provider}"
    },
    "HRIS": {
        "disclaimer": "Queste informazioni sono impostate automaticamente e non possono essere modificate."
    },
    "settingGoals": {
        "description": "Concentrarsi su 3 obiettivi consigliati alla volta aumenterà le probabilità di successo.",
        "title": {
            "one": "Hai 1 obiettivo fissato"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Account già collegato a un altro utente",
            "lastAccountMessage": "Sei sicuro di voler rimuovere l'ultimo account collegato? Una volta rimosso, dovrai accedere con l'indirizzo e-mail %{email} e una nuova password.",
            "unlinkCorpAccountMessage": "Sei sicuro di voler rimuovere il tuo account aziendale collegato? Una volta rimosso, dovrai accedere nuovamente con l'indirizzo e-mail %{email}.",
            "alreadyLinked": "Account già collegato",
            "unlinkMessage": "Sei sicuro di voler rimuovere un account collegato?"
        },
        "sso": {
            "emailNotVerified": "La tua e-mail non è stata verificata."
        },
        "signIn": {
            "dontHaveAccount": "Non hai un account?",
            "enterPIN": "Inserisci il numero di identificazione del programma dell'azienda",
            "dontKnowPIN": "Non conosci il tuo PIN?",
            "pin": "PIN",
            "register": "Registra",
            "pinDescription": "Contatta l'amministratore del programma se non sei sicuro del numero di identificazione unico del programma (PIN) della tua organizzazione. Se hai un PIN e hai difficoltà a passare alla fase successiva, contatta support@sproutatwork.com.",
            "keepMeTooltip": "Per comodità, quando questa casella è selezionata la sessione rimane valida per 30 giorni. Sui dispositivi condivisi, ti consigliamo di deselezionare questa casella e di uscire al termine dell'operazione."
        },
        "signUp": {
            "backToLogin": "Torna al login",
            "termsOfService": "Termini di servizio",
            "privacyPolicy": "Informativa sulla privacy"
        },
        "createYourAccount": "Crea il tuo account",
        "setYourDetails": "Imposta i tuoi dati",
        "ModaHybridLogin": {
            "noAccessDashboard": "Non hai accesso alla Dashboard dei membri?",
            "signUpSSOButton": "Iscriviti tramite Moda Member Dashboard",
            "noAccessDashboardWeb": "Se non hai accesso alla Dashboard dei membri, accedi con la tua e-mail e password qui sotto.",
            "loginSSOButton": "Accedi tramite la Dashboard dei membri di Moda"
        }
    },
    "entityHasBeenDeleted": "%{name} è stato eliminato",
    "track_challenge": {
        "message": {
            "manually": "Registra manualmente",
            "automatically": "Registrato automaticamente con %{appOrDeviceName}",
            "manuallyOrConnect": "Registra manualmente o connetti un'app o un dispositivo",
            "manuallyAndBy": "Registra manualmente e automaticamente con %{appOrDeviceName}",
            "reconnectDevice": "Dispositivo richiesto. Riconnetti il tuo dispositivo",
            "manualAndAuto": "Registrazione manuale e automatica",
            "trackedAutomatically": "Registrato automaticamente"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Impossibile iscriversi",
            "message": "Impossibile recuperare i dati dell'utente dal partner. Riprova più tardi"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Per questo %{goalName} sono necessari un'app o un dispositivo.",
            "subTitle": "Connetti un'app o un dispositivo"
        }
    },
    "descriptionSlug": {
        "wellness": "Unisciti alla community Salute che ti aiuta a fissare obiettivi, a connetterti e a rimanere in carreggiata.",
        "goals": "Dicci a cosa stai mirando. Ti aiuteremo ad arrivarci con gli obiettivi consigliati.",
        "devices": "Sincronizza il tuo dispositivo di fitness o registra le tue attività e rimani concentrato sui tuoi obiettivi.",
        "challenges": "Stimola una competizione amichevole. Crea una sfida e invita gli altri a unirsi al divertimento.",
        "celebrate": "Rimani in contatto con i colleghi e celebrate insieme i vostri successi.",
        "habits": "Registra le attività Benessere per guadagnare punti. Collega il tuo telefono o dispositivo indossabile per guadagnare più velocemente.",
        "joinChallenge": "Scopri come reggi il confronto con i tuoi colleghi in una competizione amichevole.",
        "getSocial": "Rimani in contatto con i colleghi e celebrate insieme i vostri successi.",
        "reward_text": "Guadagna punti completando le attività quotidiane e le sfide personali.",
        "move_text": "Che si tratti di una passeggiata intorno all'isolato, di cinque minuti di mindfulness o di una sequenza di pasti salutari, sarai premiato.",
        "phone_text": "Usa i tuoi punti per ottenere sconti sulla tua copertura e offerte vantaggiose: a te la scelta.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Funzione non abilitata",
        "checkAppVersion": {
            "message": "Sembra che la tua app non sia aggiornata. Installa l'ultimo aggiornamento.",
            "button": "Aggiorna %{appName}"
        },
        "noConnection": {
            "title": "Nessuna connessione di rete",
            "description": "Sembra che tu non sia connesso a Internet. Non potrai utilizzare appieno l'app se non disponi di una connessione.",
            "button": "Riprova"
        },
        "uploadPhotoText": "Aggiungi una foto per il tuo %{entityType}",
        "entities": {
            "community": "community",
            "event": "evento",
            "team": "squadra",
            "goal": "obiettivo",
            "challenge": "sfida",
            "competition": "competizione"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Impossibile accedere",
            "resetPasswordHeading": "Richiesta la reimpostazione della password"
        },
        "signup": {
            "corporateOrOther": "Non sei un membro Medibank? O parte di un programma aziendale?",
            "sign_up_here": "Iscriviti qui",
            "errorHeading": "Impossibile iscriversi",
            "areYouMedibankMember": "Sei un membro Medibank?",
            "isMedibankMember": "Sono un membro",
            "isNotMedibankMember": "Non sono un membro"
        },
        "bpidExists": "L'e-mail fornita è già associata a un utente Vivere meglio. L'e-mail deve essere unica.",
        "generalError": "Servizio attualmente non disponibile"
    },
    "rewardsNoAvailableProducts": "Al momento non ci sono prodotti disponibili.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Sei ancora in tempo per registrare!",
            "no": "Il tuo %{type} è terminato"
        },
        "grace": "Il tuo %{type} potrebbe essere terminato, ma hai %{n} %{text} per registrare eventuali attività dimenticate.",
        "notGrace": {
            "goal": "Congratulazioni per aver completato il tuo obiettivo! Continua a lavorare bene fissando un nuovo obiettivo per rimanere in linea con il tuo benessere.",
            "competition": "Congratulazioni per aver completato la sfida! Mantieni lo slancio partecipando a un'altra sfida o creandone una tua."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Connetti il tuo dispositivo o l'app e registra facilmente. La tua autenticazione consente al nostro partner tecnologico \"Sprout\" di trasferire in modo sicuro i tuoi dati dal tuo account %{appDeviceTitle}."
    },
    "noTransactionsMessage": "Sembra che tu non abbia effettuato alcuna transazione.",
    "noRedemptionsMessage": "Sembra che tu non abbia ancora riscattato nulla.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Puoi competere nelle sfide singolarmente o come squadra",
            "prompt": "Non ci sono sfide a cui partecipare in questo momento. Perché non crearne una?"
        },
        "createChallengeButton": "Crea una sfida"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Gli eventi possono essere solo su invito o aperti a tutti.",
            "button": "Crea un evento"
        },
        "emptyEventsMessage": "Non ci sono eventi a cui partecipare in questo momento. Perché non crearne uno?"
    },
    "appnameLiveBetter": "Vivere meglio",
    "appnameTelus": "Benessere",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Non hai fissato alcun obiettivo!",
            "descriptionNoSet": "Migliora il tuo punteggio Benessere fissando alcuni obiettivi. Inizia rapidamente con un obiettivo consigliato, scegli dal catalogo o creane uno tuo.",
            "descriptionSet": "Puoi impostare uno degli obiettivi consigliati per te, sfogliare il catalogo completo o creare il tuo obiettivo personale.",
            "action_text": "Fissa un nuovo obiettivo",
            "heading_singular": "Puoi fissare 1 altro obiettivo",
            "heading_plural": "Puoi fissare altri %{number} obiettivi"
        },
        "heading": "Obiettivi personali",
        "single": "Obiettivo personale"
    },
    "settingGoal": {
        "yourGoal": "Le tue %{units}",
        "yourGoalDescription": "Sei sulla buona strada! Le seguenti %{units} saranno impostate e si avvieranno subito.",
        "selectedGoals": "Obiettivi selezionati",
        "recommendedDescription": {
            "maximumSet": "Hai il numero massimo di obiettivi fissati. Puoi dare uno sguardo e fissare nuovi obiettivi dopo aver completato quelli attuali.",
            "maximumSetTitle": "Hai %{count} obiettivi fissati"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "L'attività è stata rimossa",
            "info": "Qualcosa è andato storto. Riprova.",
            "danger": "Qualcosa è andato storto. Riprova."
        },
        "plural": {
            "success": "Le attività sono state rimosse",
            "info": "Qualcosa è andato storto. Riprova.",
            "danger": "Qualcosa è andato storto. Riprova."
        },
        "success": "L'attività è stata rimossa",
        "info": "L'attività non è stata rimossa. Riprova.",
        "danger": "L'attività non è stata rimossa. Riprova."
    },
    "participants": "Partecipanti",
    "members": "Membro\/i",
    "timeSittingInformationOld": "Le linee guida raccomandano di:\n - Ridurre al minimo la posizione seduta per periodi di tempo prolungati.\n - Spezzare i lunghi periodi in posizione seduta il più spesso possibile.",
    "timeSittingInformation": {
        "title": "Le linee guida raccomandano di:",
        "list": "- Ridurre al minimo la posizione seduta per periodi di tempo prolungati.\n - Spezzare i lunghi periodi in posizione seduta il più spesso possibile."
    },
    "activityLevelInformationOld": "Le linee guida raccomandano di:\n - Essere attivi la maggior parte dei giorni della settimana, e preferibilmente tutti i giorni.\n - Accumulare oltre 150 minuti di attività fisica di intensità moderata ogni settimana.\n - Svolgere attività di rafforzamento muscolare almeno 2 giorni alla settimana.",
    "activityLevelInformation": {
        "title": "Le linee guida raccomandano di:",
        "list": "- Essere attivi la maggior parte dei giorni della settimana, e preferibilmente tutti i giorni.\n - Accumulare oltre 150 minuti di attività fisica di intensità moderata ogni settimana.\n - Svolgere attività di rafforzamento muscolare almeno 2 giorni alla settimana."
    },
    "viewGuidelines": "Visualizza le linee guida",
    "corporateAccountLink": {
        "verification": {
            "title": "Verifica il tuo indirizzo e-mail di lavoro",
            "description": "Per completare il processo di collegamento devi verificare il tuo indirizzo e-mail di lavoro. Segui le istruzioni inviate a:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Trova amici e familiari",
        "findFriends&Family": "Trova amici e familiari",
        "tapToAddFriendsAndFamily": "Tocca per aggiungere amici e familiari",
        "addedFriendsAndFamily": "Aggiunto ad amici e familiari",
        "whoYouAreLookingFor": "Non trovi chi stai cercando?",
        "inviteWithEmail": "Invita tramite e-mail",
        "sentInvitations": "Inviti inviati",
        "foundPerson": "Abbiamo trovato questa persona con un'e-mail corrispondente",
        "youAreBoth": "Siete entrambi in %{entityName}",
        "youAreBothMore": "Siete entrambi in %{entityName}, +%{n} altro",
        "noFriendsAndFamilyAdded": "Sembra che tu non abbia ancora aggiunto amici o familiari.",
        "sendInvitation": "Invia invito",
        "youHaveNoSentInvitations": "Non hai inviato alcun invito",
        "toast": {
            "success_title": "Invito inviato",
            "success_description": "%{invite_email} vedrà l'invito nella sua casella di posta.",
            "danger_title": "L'invito non è andato a buon fine",
            "danger_description": "Riprova più tardi"
        },
        "email": {
            "invalid_email": "Inserisci un indirizzo e-mail valido"
        },
        "inviteOthers": "Invita gli altri",
        "searchForSomeone": "Cerca qualcuno",
        "searchForOthersToInvite": "Cerca altri da invitare",
        "programNameOnly": {
            "title": "Solo %{programName}",
            "description": "Questo %{entityType} è disponibile solo per le persone che fanno parte di %{programName}"
        },
        "domainCannotBeUsed": "Questo dominio non può essere utilizzato con %{programName}",
        "actionSearchByEmail": "Invita tramite e-mail se non riesci a trovare la persona che stai cercando",
        "send": "Invia",
        "addEmailToList": "Aggiungi e-mail all'elenco",
        "toBeSent": "Inviti da inviare",
        "noInvitationsToBeSent": "Nessun invito",
        "removeEmailConfirmation": "Sei sicuro di voler rimuovere questa e-mail dall'elenco?",
        "yes": "Sì",
        "no": "No",
        "foundByEmail": "Abbiamo trovato questa persona con un'e-mail corrispondente",
        "addToFriendsAndFamily": "Aggiungi ad amici e familiari",
        "alreadyAddedEmail": "Hai già aggiunto questa e-mail all'elenco"
    },
    "pointsCurrencyAdditionalInfo": "I tuoi %{points_name} e i tuoi livelli ricominciano ogni %{period}. Tutte le attività registrate contribuiscono al livello complessivo del periodo.",
    "rankLabel": "Posizione",
    "leaderboards": {
        "loadingLabel": "Caricamento delle classifiche in corso Potrebbe volerci qualche minuto: sembra che tutti siano in giro a fare attività fisica!"
    },
    "feeds": {
        "emptyListHomePage": "Non ci sono ancora post da mostrare. Prova a rettificare lo stream per mostrare più post.",
        "viewingPostsFrom": "Visualizzazione dei post di",
        "postActivity": "Aggiungi un commento o una foto sulle tue attività!",
        "indicatorLoader": {
            "defaultTitle": "Aggiornamento in corso",
            "successfulLoadedTitle": "Sincronizzato e aggiornato"
        },
        "inapropriateTextError": {
            "message": "Il contenuto del tuo messaggio potrebbe essere inappropriato. Cerca di usare un linguaggio più amichevole."
        },
        "postImageError": {
            "title": "Siamo spiacenti, non possiamo pubblicarla",
            "message": "La foto aggiunta potrebbe essere inappropriata. Prova con un'altra."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Connessione a %{name} in corso",
            "description": "Per connettere i tuoi dati %{name} al tuo account, procedi come segue:",
            "firstStep": "Scarica e installa l'app mobile %{appName} da %{storeName}",
            "fourthStep": "Seleziona per connettere con %{name}",
            "fifthStep": "Quando ti verrà richiesto, seleziona le metriche sulla salute da sincronizzare con %{appName} e premi \"Fine\"",
            "additionalInfo": "Per attivare la sincronizzazione dall'app Salute, %{appName} deve essere aperta. Non è necessario tenere aperta l'app, ma potrebbe essere necessaria un'ora affinché la sincronizzazione sia completata e appaia nel tuo registro delle attività."
        },
        "title": "Sincronizzazione di %{name} in corso",
        "description": "Per sincronizzare i tuoi dati %{name} con il tuo account, procedi come segue:",
        "steps": {
            "one": "Accedi alla tua app %{appName} sul tuo telefono",
            "two": "Apri la sezione App e Dispositivi nel tuo profilo",
            "three": "Premi il pulsante di sincronizzazione accanto a %{name}",
            "iPhone": "Accedi alla tua app %{appName} sul tuo iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Account di lavoro",
            "message": "L'account è stato connesso con successo"
        },
        "danger": {
            "message": "Errore di connessione dell'account"
        },
        "conflict": {
            "message": "L'account è già collegato a un altro utente"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Account di lavoro",
            "message": "Account disconnesso con successo"
        },
        "danger": {
            "title": "Collega account",
            "message": "Errore nella disconnessione dell'account"
        }
    },
    "earnMoreWithPartners": "Guadagna di più con i partner",
    "connectPartnersToEarnByShopping": "Connetti i tuoi account e guadagna più %{unit_type} acquistando con i partner di %{program_name}.",
    "viewAllPartners": "Visualizza tutti i partner",
    "myPartnerMemberships": "Le mie iscrizioni con i partner",
    "linkAccount": "Collega iscrizione",
    "linkToPartner": "Collegamento al partner",
    "linkingError": "Si è verificato un problema nel collegare il tuo account. Riprova.",
    "linkPending": "Collegamento in sospeso",
    "unlinkAccount": "Scollega account",
    "linkedToPartnerName": "Collegato a %{partner_name}",
    "linked": "Collegato",
    "permission": {
        "facebookTitle": "Iscriviti con Facebook",
        "googleTitle": "Iscriviti con Google",
        "facebookDescription": "Al momento dell'iscrizione con Facebook, dovrai concedere il permesso al nostro partner tecnologico \"Sprout\" di accedere alla tua identità e creare il tuo account %{programName}.",
        "googleDescription": "Al momento dell'iscrizione con Google, dovrai concedere al nostro partner tecnologico \"Sprout\" l'autorizzazione ad accedere alla tua identità e creare il tuo account %{programName}.",
        "camera": {
            "title": "Accesso alla fotocamera",
            "description": "Per scattare una foto è necessario l'accesso alla fotocamera. Nelle impostazioni dell'iPhone, tocca %{appName} e attiva Fotocamera.\n \n Si noti che le modifiche non salvate potrebbero andare perse."
        },
        "notNow": "Non ora",
        "openSettings": "Apri impostazioni",
        "photos": {
            "title": "Consenti l'accesso alle foto",
            "description": "Questo ti consente di condividere le foto dalla libreria e di salvare le foto nelle tue Foto. Nelle impostazioni dell'iPhone, tocca %{appName} e passa da Foto a Testo attivo.\n \n Si noti che le modifiche non salvate potrebbero andare perse."
        }
    },
    "firstNameContainsSpecialChar": "Il tuo nome può contenere solo lettere inglesi, trattini - e apostrofi",
    "lastNameContainsSpecialChar": "Il tuo cognome può contenere solo lettere inglesi, trattini - e apostrofi '",
    "goToPartnerSite": "Vai al sito del partner",
    "noPartnersFound": "Nessun partner trovato",
    "noLinkedPartners": "Nessun partner connesso",
    "noPartnersInCategory": "Nessun partner nella categoria",
    "partnerAccountPendingVerification": "Verifica dell'account in corso",
    "shopWithPartner": "Acquista con il partner",
    "shopWithPartnerName": "Acquista con %{partner_name}",
    "linkToPartnerName": "Collegamento a %{partner_name}",
    "earnPartnerMembershipIdentifier": "ID iscrizione",
    "earnPartnerAccountPendingAddLink": "La tua iscrizione è in fase di collegamento e potrebbe richiedere alcuni giorni per essere completata.",
    "earnPartnerAccountPendingRemoveLink": "La tua iscrizione è in corso di disconnessione e potrebbe richiedere alcuni giorni per essere completata.",
    "linkStatusUpdating": "Aggiornamento dello stato dei collegamenti",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Congratulazioni per aver aggiunto le prime attività! \n \n Se lo desideri, puoi aggiungere altre attività per oggi e per gli altri giorni. Una volta terminate le attività di oggi, tocca",
            "description2": "nella schermata successiva, quando non hai più nulla da registrare."
        },
        "listTitle": "Attività registrate su",
        "dots": {
            "tracked": "Attività registrate in questo giorno",
            "added": "Le attività sono state aggiunte e sono in attesa di essere inviate"
        },
        "trackedActivitiesFor": "Attività registrate per %{date}",
        "activityTracking": "Registrazione dell'attività",
        "addedPending": "Aggiunto (in attesa di invio)",
        "search": {
            "description1": "Tocca",
            "description2": "per vedere le attività disponibili o cercare un'attività specifica"
        },
        "addActivity": "Aggiungi attività",
        "addAnotherActivity": "Aggiungi un'altra attività"
    },
    "rewardsBalance": "Saldo %{currencyName}: %{points}",
    "membershipIdentifierRequiredError": "Il tuo ID iscrizione è necessario per il collegamento",
    "incorrectValueInRange": "Inserisci un valore compreso tra %{min} e %{max}.",
    "joinTeam": {
        "title": "Unisciti alla squadra",
        "createInsteadText": "Unisciti o crea una squadra per partecipare a questa sfida"
    },
    "teamRank": "Posizione della squadra",
    "teamScore": "Punteggio della squadra",
    "appsDevices": {
        "infoText": "Ti verrà chiesto di autorizzare il nostro partner tecnologico Sprout Wellness Solutions, Inc. ad accedere ai tuoi dati Benessere quando aggiungi un'app o un dispositivo.",
        "connectModal": {
            "title": "Autorizzazione",
            "paragraph1Part1": "Ti verrà chiesto di autorizzare il nostro partner tecnologico",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "ad accedere ai tuoi dati Benessere.",
            "paragraph2Desc1": "L'autorizzazione consente a",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "di sincronizzare in modo sicuro i tuoi",
            "paragraph2Desc4": "dati con",
            "paragraph2Desc5": ", e ti aiuta a guadagnare più %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Connetti un'app o un dispositivo di registrazione dell'attività e rendi la sincronizzazione e la registrazione dell'attività un gioco da ragazzi",
            "connectAction": "Connetti un'app o un dispositivo",
            "errorMessage": "Alcune app o alcuni dispositivi connessi non riescono a sincronizzarsi",
            "warningMessage": "Alcune app o alcuni dispositivi connessi potrebbero avere un problema di connessione",
            "errorAction": "Correggi questo errore",
            "warningAction": "Correggi questo avviso",
            "syncingError": "Errore di sincronizzazione",
            "syncingIssue": "Problema di sincronizzazione"
        },
        "deviceDetails": {
            "warningMessage": "Questa app o questo dispositivo hanno problemi di sincronizzazione",
            "errorMessage": "Questa app o questo dispositivo non sono in grado di sincronizzarsi",
            "warningAction": "Rimuovi avviso",
            "noActivities": "Nessuna attività di %{deviceName} è stata sincronizzata con %{programName} negli ultimi 7 giorni. \n \n Le attività possono impiegare fino a un'ora per essere visualizzate qui dopo essere state registrate con %{deviceName}.\n \n Se un'altra app o un altro dispositivo sono collegati e sono stati registrati più passi dall'altra app o dall'altro dispositivo, l'attività viene visualizzata lì. Altrimenti, prova a scollegare e ricollegare %{deviceName}. Se ti viene chiesto di autenticarti o di concedere autorizzazioni, assicurati di aver abilitato i dati sulle attività e di utilizzare per l'autenticazione lo stesso account usato per registrare le attività. Per ulteriori informazioni, consulta le fasi di risoluzione dei problemi."
        },
        "troubleshooting": "Risoluzione dei problemi",
        "deviceItem": {
            "error": "Errore di connessione",
            "warning": "Avviso di connessione",
            "unableToSync": "Impossibile sincronizzare"
        },
        "platformDevice": {
            "defaultApp": "L'app salute predefinita del dispositivo è",
            "continueMore": "Continua con altre app e altri dispositivi"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Scopri di più su amici e familiari",
        "learnModal": {
            "title": "Informazioni su amici e familiari",
            "description": "Dopo aver aggiunto qualcuno ai tuoi amici e familiari, puoi scegliere di condividere i tuoi post su %{programName} solo con loro.\n \n Puoi anche filtrare i post che vedi su %{programName} solo per le persone presenti nel tuo elenco di amici e familiari, se questi hanno inviato post a tutti o a te.",
            "description_line1": "Dopo aver aggiunto qualcuno ai tuoi amici e familiari, puoi scegliere di condividere i tuoi post su %{programName} solo con loro.",
            "description_line2": "Puoi anche filtrare i post che vedi su %{programName} solo per le persone presenti nel tuo elenco di amici e familiari, se questi hanno inviato post a tutti o a te.",
            "whatIconsMean": "Significato delle icone",
            "canAdd": "Aggiungi",
            "added": "Aggiunto"
        },
        "searchDescription1": "Cerca persone da aggiungere ai tuoi amici e familiari.",
        "searchDescription2": "Non trovi chi stai cercando? Invitalo a partecipare tramite e-mail.",
        "friends&Family": "Amici e familiari",
        "managingTour": {
            "title": "Gestione di amici e familiari",
            "body": "Se desideri eliminare qualcuno dai tuoi amici e familiari, tocca l'icona"
        },
        "removeOption": "Elimina da amici e familiari",
        "inviteDescription1": "Cerca i tuoi amici e familiari.",
        "inviteDescription2": "Non trovi chi stai cercando?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "I post che condividi solo con amici e familiari non saranno più visibili a %{userFirstName}."
        }
    },
    "skipAll": "Salta tutto",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "Sei sicuro?",
            "description": "In caso di necessità, puoi sempre contattare il Programma di assistenza ai dipendenti e alle famiglie dal tuo profilo."
        },
        "contact": {
            "whatIsBestNumber": "Qual è il numero dove preferisci essere contattato?",
            "whatIsBestTime": "Qual è il momento migliore per contattarti?",
            "morning": "Mattina",
            "afternoon": "Pomeriggio",
            "evening": "Sera",
            "additionalDetails": "Ulteriori dettagli sull'ora\/sulla data in cui desideri essere contattato",
            "message": "Contattami il %{weekDay} al numero %{phoneNumber}. Informazioni aggiuntive: %{additional}",
            "description": "Nota: Ti consigliamo vivamente di scegliere un momento al di fuori dell'orario di lavoro e di scegliere un luogo in cui ti sia possibile conversare privatamente. Includi il tuo fuso orario."
        },
        "phoneNumber": {
            "empty": "Questo campo non può essere vuoto",
            "missingDigits": "Il numero di telefono deve contenere almeno 4 cifre"
        },
        "myEAP": "Il mio programma di assistenza ai dipendenti e alle famiglie"
    },
    "healthSurveySkipAllTitle": "Salta il Sondaggio sul benessere",
    "healthSurveySkipAllAlert": "Sei sicuro di voler saltare tutte le altre domande del Sondaggio sul benessere?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Programma di assistenza ai dipendenti e alle famiglie",
            "message": "Indica il tuo numero di telefono e l'orario migliore per contattarti"
        }
    },
    "allMyChallenges": "Le mie sfide",
    "invitedChallenges": "Inviti",
    "companyChallenges": "Sfide aziendali",
    "completedChallengesEmpty": "Sembra che tu non abbia ancora completato nessuna sfida.",
    "myChallengesEmpty": "Sembra che tu non ti sia ancora iscritto a nessuna sfida.",
    "allChallengesEmpty": "Non ci sono sfide.",
    "startsToday": "Inizia oggi",
    "startedDaysAgo": "Iniziata %{dayCount} giorni fa",
    "startsInDays": "Inizia tra %{dayCount} giorni",
    "privacyOn": "Disattivata",
    "privacyOff": "Il",
    "dashboard": {
        "viewLeaderboard": "Visualizza la classifica",
        "timePeriodProgress": "I tuoi progressi in questo %{period}",
        "howToEarn": "Come guadagnare punti"
    },
    "privacyChangeConfirmationMessage": "Vuoi cambiare le impostazioni sulla privacy?",
    "privacySettingsTitle": "Privacy",
    "privacySettingsDescription": "Puoi controllare la visibilità della tua foto, del tuo nome e del tuo profilo agli altri utenti.",
    "mainLeaderBoardSettingsTitle": "Classifica generale",
    "challengeLeaderBoardSettingsTitle": "Classifica della sfida",
    "managePrivacySettingUrlTitle": "Gestisci le impostazioni sulla privacy",
    "onboardingFamilyPrivacySettingsMessageOn": "Sei visibile nei risultati di ricerca di amici e familiari. Puoi scegliere di nasconderti dai risultati di ricerca.",
    "onboardingFamilyPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy ti nascondono nei risultati di ricerca di amici e familiari.",
    "challengeInvitationPrivacySettingsMessageOn": "Sei visibile nei risultati di ricerca degli inviti alle sfide. Puoi scegliere di nasconderti dai risultati di ricerca.",
    "challengeInvitationPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy ti nascondono nei risultati di ricerca degli inviti.",
    "challengeParticipationPrivacySettingsMessageOn": "Sei elencato come partecipante a questa sfida. Puoi scegliere di nasconderti come partecipante alle tue sfide.",
    "challengeParticipationPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy non ti nascondono dall'elenco dei partecipanti.",
    "communityInvitationPrivacySettingsMessageOn": "Sei visibile nei risultati di ricerca degli inviti della community. Puoi scegliere di nasconderti dai risultati di ricerca.",
    "communityInvitationPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy ti nascondono dai risultati di ricerca degli inviti della community.",
    "communityParticipationPrivacySettingsMessageOn": "Sei elencato come membro di questa community. Puoi scegliere di nasconderti come membro dalle tue community.",
    "communityParticipationPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy ti nascondono dall'elenco dei membri.",
    "eventInvitationPrivacySettingsMessageOn": "Sei visibile nei risultati di ricerca degli inviti agli eventi. Puoi scegliere di nasconderti dai risultati di ricerca.",
    "eventInvitationPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy ti nascondono dai risultati di ricerca degli inviti agli eventi.",
    "eventParticipationPrivacySettingsMessageOn": "Sei elencato come iscritto a questo evento. Puoi scegliere di nasconderti come iscritto ai tuoi eventi.",
    "eventParticipationPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy non ti nascondono dall'elenco degli iscritti.",
    "mainLeaderboardPrivacySettingsMessageOn": "Sei mostrato nelle classifiche generali. Puoi scegliere di nasconderti, in modo da eliminare la tua posizione, la tua foto e il tuo nome quando gli altri visualizzano le classifiche generali.",
    "mainLeaderboardPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy ti nascondono quando gli altri visualizzano le classifiche generali.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Sei mostrato nelle classifiche delle sfide. Puoi scegliere di nasconderti, in modo da eliminare la tua posizione, la tua foto e il tuo nome quando gli altri visualizzano le classifiche delle sfide.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Attualmente le tue impostazioni sulla privacy ti nascondono quando gli altri visualizzano le classifiche delle sfide.",
    "thumbsUpConfirmationTitle": "Pollici in su",
    "thumbsUpConfirmationDescriptionline1": "Congratulazioni, stai per dare il tuo primo pollice in su e incoraggiare gli altri!",
    "thumbsUpConfirmationDescriptionline2": "Verrai inserito nell'elenco delle persone che hanno dato il pollice in su a questo post e gli altri potranno vedere la tua foto, il tuo nome e il tuo profilo.",
    "thumbsUpConfirmationButtonOk": "Pollici in su",
    "commentToActionInfoTitle": "Cosa vedono gli altri?",
    "commentToActionMessage": "Quando commenti, gli altri possono vedere la tua foto, il tuo nome e il tuo profilo.",
    "postToActionTitle": "Chi vede questo post?",
    "postToActionMessageLine1": "Quando crei un post, puoi controllare chi può vederlo e persino inviarlo solo a te stesso.",
    "postToActionMessageLine2": "I post che condividi con gli altri mostreranno la tua foto, il tuo nome e gli altri potranno visualizzare il tuo profilo.",
    "privateUsersDescriptionChallenge": "Questo\/i partecipante\/i si è\/sono nascosto\/i dall'elenco",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privato",
    "privateUsersLastNamePlaceHolderChallenge": "partecipante\/i",
    "privateUsersDescriptionEvent": "Questo\/i iscritto\/i si è\/sono nascosto\/i dall'elenco",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privato",
    "privateUsersLastNamePlaceHolderEvent": "iscritto\/i",
    "privateUsersDescriptionCommunity": "Questo\/i membro\/i si è\/sono nascosto\/i dall'elenco",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privato",
    "privateUsersLastNamePlaceHolderCommunity": "membro\/i",
    "noPrivacySettings": "Nessuna impostazione sulla privacy",
    "linkToPartnerNameWebsite": "Collegamento tramite il sito Web di %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL del sito Web del partner",
    "start_end_time": "Ora di inizio e di fine:",
    "joinCreateTeamPrivacyDisclaimer": "La tua foto, il tuo nome e il tuo profilo saranno sempre visibili a chiunque visualizzi la tua squadra in una sfida, anche se hai modificato le tue Impostazioni sulla privacy in Privato.",
    "carouselInstructions": {
        "swipe": "Scorri le schede per vedere tutti i tuoi obiettivi e le tue sfide.",
        "click": "Fai clic sulle schede per vedere tutti i tuoi obiettivi e le tue sfide."
    },
    "achieved": "Raggiunto",
    "hours": "ore",
    "createCommunityFlow": {
        "navigatorTitle": "Crea una community",
        "stepType": {
            "title": "Visibilità della community",
            "subTitle": "Chi potrà vedere e partecipare alla community?",
            "privateName": "Privato",
            "publicName": "Pubblico",
            "privateDescription": "Solo le persone invitate potranno vedere o unirsi alla community.",
            "publicDescription": "Chiunque può vedere e unirsi a questa community"
        },
        "stepName": {
            "title": "Dai un nome alla tua community",
            "subTitle": "Dai alla tua community un nome che faccia capire le sue caratteristiche.",
            "namePlaceholder": "Nome della community",
            "noFieldsTitle": "Nome",
            "noFieldsMessage": "Nessun nome dato"
        },
        "stepDescription": {
            "title": "La tua community",
            "subTitle": "Racconta agli altri le caratteristiche della tua community.",
            "descriptionPlaceholder": "Descrizione (campo facoltativo)",
            "noFieldsTitle": "Descrizione",
            "noFieldsMessage": "Nessuna descrizione fornita"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Aggiungi una foto"
        },
        "stepJoin": {
            "title": "Abbiamo trovato community simili",
            "subTitle": "Piuttosto vuoi unirti a una di queste community?"
        },
        "createNew": "Crea una nuova community"
    },
    "challengeCard": {
        "allActivities": "Tutte le attività della",
        "category": "categoria"
    },
    "myLinkedPartners": "I miei partner collegati",
    "leaderboardPosition": "Posizione in classifica generale",
    "remainingInChallenge": "rimasti nella sfida",
    "todays_progress": "I progressi di oggi",
    "this_weeks_progress": "I progressi di questa settimana",
    "this_months_progress": "I progressi di questo mese",
    "achievement": "traguardo",
    "challengeCardHeader": {
        "challenge": "Sfida",
        "recommended_personal_goals": "Obiettivo personale consigliato",
        "personal_goal": "Obiettivo personale",
        "competition": "Competizione",
        "recommended_goals": "Obiettivo consigliato",
        "team_competition": "Competizione a squadre",
        "team": "Squadra"
    },
    "MyMedibank": "La mia Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "L'ora di fine non può essere precedente all'ora di inizio",
    "company": "Azienda",
    "lessThan1DayRemain": "meno di 1 giorno",
    "lessThan1HourRemain": "meno di 1 ora",
    "remainingToday": "rimasto oggi",
    "periodEndsDateAndTime": "Il periodo termina %{date}, %{time}",
    "moreToGo": "%{n} altra %{unit} da cui partire",
    "reachedYourGoal": "Hai raggiunto il tuo obiettivo %{period}!",
    "reachedYourGoalToday": "Oggi hai raggiunto il tuo obiettivo!",
    "editProfileItemCorrectRange": "Fornisci un valore %{itemName} valido tra il valore minimo %{min} e il valore massimo %{max}",
    "invalidUrl": "URL non valido",
    "activityLogChanged": {
        "success": "Le modifiche all'attività sono state salvate",
        "info": "Qualcosa è andato storto Riprova.",
        "danger": "Qualcosa è andato storto Riprova."
    },
    "discardAlert": {
        "createChallenge": "Sei sicuro di voler cancellare questa %{challengeType}?",
        "inviteByEmail": "Sei sicuro di voler cancellare le modifiche?",
        "createTeam": "Sei sicuro di voler annullare la creazione di questa squadra?",
        "cancel": "Annulla",
        "confirm": "Sì, cancella"
    },
    "entityInvalidNameError": "Il nome della %{entity} deve contenere solo numeri o stringhe e non può essere vuoto",
    "accept": "Accetta",
    "sync_now": "Sincronizza ora",
    "reconnect_device": "Riconnettiti",
    "supported_activities": "Attività supportate",
    "recentlySynced_activity": "Attività sincronizzate di recente",
    "noSyncedActivity_sevenDays": "Non sono state sincronizzate attività negli ultimi 7 giorni",
    "recentActivityLog": {
        "convertingActivityPoints": "Sincronizzazione delle attività in corso",
        "activityMinuteOrTwo": "Questa operazione potrebbe richiedere uno o due minuti",
        "noNewActivities": "Nessuna nuova attività aggiunta La sincronizzazione delle nuove attività può richiedere fino a un'ora."
    },
    "deleteCommunityCheckbox": "Capisco che questa azione non può essere annullata",
    "createEvent": {
        "type": {
            "company": "Evento aziendale",
            "user": "Evento utente",
            "title": "Tipo di evento"
        },
        "privacy": "Privacy (mostra o meno gli iscritti)",
        "cost": "Costo",
        "associated": {
            "location": "Sede associata",
            "department": "Dipartimento\/divisione associato\/a"
        },
        "maxParticipants": "Max Partecipanti (campo facoltativo)",
        "errorMessage": {
            "limit": "Non può essere maggiore di %{maxValue}",
            "negative": "Non può essere un valore negativo",
            "selectedLocations": "Seleziona una o più sedi"
        },
        "selectLocations": "Sedi selezionate",
        "createNew": "Crea un nuovo evento"
    },
    "selected": "Selezionato",
    "deleteEventButton": "Elimina questo evento",
    "notification": {
        "priorityNotification": {
            "title": "Hai aggiornamento importanti non letti",
            "subtitle": "Tocca per leggerli ora",
            "subtitleWeb": "Fai clic per leggerli ora"
        },
        "sectionTitle": {
            "priorityUnread": "Aggiornamenti importanti non letti",
            "all": "Tutte le notifiche"
        },
        "modalTitle": "Hai %{count} aggiornamenti importanti",
        "priorityModalTitle": {
            "defaultTitle": "Visualizza tutti gli aggiornamenti"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Annulla %{entity} %{actionType}",
            "message": "Sei sicuro di voler annullare %{entity} %{actionType}?"
        },
        "action": {
            "creating": "creazione in corso",
            "editing": "modifica in corso"
        },
        "type": {
            "team": "squadra",
            "community": "community",
            "event": "evento",
            "challenge": "sfida",
            "goal": "obiettivo"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Vuoi renderlo pubblico?",
            "private": "Vuoi renderlo privato?"
        },
        "modalSubtitle": {
            "public": "Rendendo questo %{entityType} pubblico, tutti potranno saperlo e partecipare. Sei sicuro di voler rendere questo %{entityType} pubblico?",
            "private": "Rendendo questo %{entityType} privato, nessuno potrà saperlo e partecipare. Sei sicuro di voler rendere questo %{entityType} pubblico?"
        },
        "footerButton": {
            "makePublic": "Sì, rendilo pubblico",
            "makePrivate": "Sì, rendilo privato",
            "keepPrivate": "Mantienilo privato",
            "keepPublic": "Mantienilo pubblico"
        },
        "label": {
            "title": "Rendilo un %{entityType} pubblico",
            "subtitle": "Tutti possono vedere e tutti possono partecipare"
        }
    },
    "imageUploader": {
        "changeImageButton": "Cambia immagine"
    },
    "copyright": "Copyright © Sprout 2019",
    "samsunghealth_not_available": "Impossibile connettersi con Samsung Health. Nell'app Salute, alla voce Autorizzazioni dati, assicurati di aver abilitato almeno l'autorizzazione ai passi e di aver registrato almeno 1 passo.",
    "rewardsHowDoIEarn": "Come posso guadagnare %{currencyName}?",
    "unlockAchievements": "Sblocca traguardi",
    "unlockAchievementsDescription": "Registra attività, guadagna %{pointsName}, sblocca livelli e guadagna più %{currencyName}. Tocca ciascun traguardo per vedere cosa ti aspetta.",
    "myDay": "La mia giornata",
    "myGoalsChallengesTasks": "I miei obiettivi, le mie sfide e i miei compiti",
    "yourGoalsChallenges": "I tuoi obiettivi e le tue sfide",
    "mySocialStream": "Post della community",
    "viewAllAchievements": "Visualizza tutti i traguardi",
    "viewAllBonusChallenges": "Visualizza tutte le sfide bonus",
    "newVersionOfAppAvailable": "Nuova versione disponibile! Ricarica questa pagina",
    "noBonusChallengesToDisplay": "Al momento non sono disponibili sfide bonus.",
    "bonusChallenges": "Sfide bonus",
    "reloadAppVersion": "Ricarica",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Sei sicuro di voler smettere di registrare %{activity_name}?",
    "activity_tracker_instruction_header": "Tocca un giorno per registrare le attività di quel giorno o vedi cosa è stato già registrato.",
    "alertDashboardFunctionalityToBeAdded": "qui verrà aggiunto del testo per spiegare cos'è un periodo di registrazione, in modo simile a come avviene per i programmi di fidelizzazione delle compagnie aeree, dove gli utenti devono continuare ad accumulare \"miglia\" in un anno solare per ottenere lo status per l'anno successivo.",
    "noNumberEntered": "Inserisci la quantità di attività",
    "feed": "Stream",
    "home": "Home",
    "challenges": "Sfide",
    "explore": "Scopri",
    "rewards": "Premi",
    "reward": "premio",
    "balance": "Il mio saldo premi %{programName}",
    "profile": "Profilo",
    "loading": "Caricamento in corso",
    "me": "Io",
    "back": "Indietro",
    "next": "Avanti",
    "skip": "Salta",
    "signup": "Iscriviti",
    "signin": "Accedi",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Accedi a Vivere meglio",
    "signup_with_medibank": "Iscriviti come membro Medibank",
    "signup_with_facebook": "Iscriviti con Facebook",
    "signup_with_google": "Iscriviti con Google",
    "signup_with_email": "Iscriviti con l'e-mail",
    "signin_with_medibank": "Accedi con La mia Medibank",
    "signin_with_facebook": "Accedi con Facebook",
    "signin_with_google": "Accedi con Google",
    "signin_with_email": "Accedi con l'e-mail",
    "signup_heading": "Crea un account",
    "not_a_medibank_member": "Non sei un membro Medibank?",
    "keep_me_signed_in": "Mantieni l'accesso",
    "forgotpassword": "Password dimenticata?",
    "emailaddress": "Indirizzo e-mail",
    "password": "Password",
    "enterEmailAddress": "Inserisci il tuo indirizzo e-mail",
    "enterYourPassword": "Inserisci la tua password",
    "password_for_error": "password",
    "reset_password": "Reimposta password",
    "passwordResetSuccess": "Reimpostazione della password",
    "passwordResetEmailSent": "Se nel nostro sistema è presente un'e-mail corrispondente, allora le istruzioni per la reimpostazione della password saranno inviate tramite e-mail.",
    "loginerror": "Si è verificato un errore durante l'accesso:",
    "logincancelled": "Accesso annullato",
    "part_of_corporate_program": "Ti stai iscrivendo a un programma aziendale?",
    "continue_here": "Continua qui",
    "program_name": "Nome del programma",
    "error_provide_program_name": "Indica un nome del programma.",
    "program_not_found": "Programma non trovato",
    "registration_field_email": "E-mail",
    "employeeId": "ID dipendente",
    "registration_field_firstName": "Nome di battesimo",
    "registration_field_lastName": "Cognome",
    "no_first_name": "Nessun nome",
    "no_last_name": "Nessun cognome",
    "registration_field_password": "Nuova password",
    "no_disclaimer_available": "Ops, c'è stato un problema Non siamo riusciti a recuperare i termini e le condizioni della tua organizzazione. Prova a registrarti di nuovo più tardi.",
    "registration_account_not_registered": "Sembra che tu non abbia ancora verificato il tuo indirizzo e-mail. Desideri ricevere nuovamente l'e-mail?",
    "resend_verification_email": "Verifica e-mail",
    "resend_verification_email_successful": "Abbiamo inviato nuovamente l'e-mail di verifica.",
    "resend_verification_email_unsuccessful": "Ops, c'è stato un problema... non siamo riusciti a inviare nuovamente l'e-mail di verifica. Riprova.",
    "not_supported": "Questo post non può essere visualizzato al momento. Riprova più tardi.",
    "policyAgreeError": "Per continuare, accetta i Termini di servizio e l'Informativa sulla privacy.",
    "challenge_completion_bonus": "Bonus di completamento",
    "me_tabs": {
        "activity": "Attività",
        "bookmarks": "Segnalibri"
    },
    "health_tab": {
        "my_health_score": "Il tuo punteggio Benessere",
        "overall_health_score_description": "Il tuo punteggio Benessere è",
        "health_score_explanation": "Il tuo punteggio Benessere viene calcolato in base alle risposte che hai fornito sulla salute e sull'attività fisica. \n \n Il tuo punteggio viene aggiornato ogni mese in base ai tuoi livelli di attività. Puoi fissare e completare obiettivi personali per migliorare il tuo punteggio Benessere.",
        "health_score_calculation_failed_onboarding": "Qualcosa è andato storto e non siamo riusciti a recuperare il tuo punteggio Benessere. Per ora puoi proseguire e non appena il problema sarà risolto, aggiorneremo il tuo punteggio."
    },
    "track_activity": "Registra attività",
    "track_an_activity": "Registra un'attività",
    "track": "Registra",
    "unable_to_track": "Impossibile registrare",
    "enter_before_track": "Immetti la quantità di attività da registrare",
    "what_to_share": "Che tipo di aggiornamento vorresti condividere?",
    "remove": "Rimuovi",
    "activity_tracking_description": "Quante %{units} desideri registrare?",
    "excessive_submission": "Wow! Stai per registrare oltre 2.000 %{customPoints} per %{activity_name}. Dovresti assicurarti che sia corretto prima di inviarlo.",
    "on": "il",
    "in": "in",
    "from": "da",
    "at": "a",
    "no_activities": "Nessuna attività corrisponde alla tua ricerca.",
    "activity_tracking_desc": "Devi aggiungere un numero per continuare. Tocca X nell'angolo a sinistra per annullare.",
    "activity_tracking_desc2": "Tocca un punto qualsiasi dell'attività per modificare, tocca + per registrare rapidamente l'obiettivo.",
    "vital_stats_title": "Informazioni su di te",
    "invalid_numeric_response": "Non valido",
    "invalid_numeric_response_range": "Questo numero deve essere compreso tra %{minimum} e %{maximum}",
    "search_placeholder": "Cerca nella libreria",
    "search_activities": "Cerca attività",
    "searching": "Ricerca in corso",
    "searchEmpty": "Nessuna corrispondenza trovata",
    "vital_stats_description": "Raccontaci un po' di te",
    "health_survey_questions": "Domande del Sondaggio sul benessere",
    "health_survey_title": "Completa il Sondaggio sul benessere",
    "health_survey_results": "Risultati del Sondaggio sul benessere",
    "health_survey_card_desc": "Partecipa al sondaggio per ottenere un'istantanea del tuo benessere e fissare obiettivi personalizzati.",
    "apps_devices_title": "Collega app e dispositivi",
    "apps_devices_card_desc": "Sincronizza le tue app e i tuoi dispositivi per guadagnare %{customPoints} in un batter d'occhio.",
    "interests_title": "Interessi",
    "interests_card_desc": "Parlaci dei tuoi interessi. Questo ci aiuterà a consigliarti obiettivi e community che potrebbero interessarti.",
    "interests_screen_desc": "A cosa sei interessato?",
    "health_obj_title": "Obiettivi di benessere",
    "health_obj_card_desc": "Riteniamo che sia giunto il momento di fissare alcuni obiettivi. Una volta conosciuti i tuoi obiettivi, saremo in grado di consigliarti meglio. Non preoccuparti, se cambi idea potrai facilmente fare delle modifiche in seguito nel tuo profilo.",
    "health_obj_screen_desc": "Su quali aree vorresti lavorare?",
    "my_heatlh_obj": "I miei obiettivi di benessere",
    "health_topic_title": "Argomenti legati al benessere",
    "health_topic_card_desc": "Personalizza la tua esperienza specificando i tuoi argomenti legati al benessere.",
    "health_topic_screen_desc": "Che cosa ti interessa apprendere?",
    "multi_select_check_error": "Seleziona almeno 1 opzione per proseguire",
    "my_health_topics": "I miei argomenti legati al benessere",
    "build_your_profile": "Costruisci il tuo profilo",
    "personalize_title": "Personalizza",
    "personalize_desc": "Personalizza la tua esperienza rispondendo a qualche veloce domanda.",
    "set_goals_title": "Vedi gli obiettivi consigliati",
    "set_goals_desc": "Fissa obiettivi personalizzati per iniziare il tuo percorso verso un te più sano.",
    "set_this_goal": "Fissa questo obiettivo",
    "goal_set": "Obiettivo fissato",
    "required": "Richiesto",
    "apps_devices_description": "Collegati a una piattaforma di fitness per guadagnare più %{customPoints} automaticamente.",
    "connected": "Connesso",
    "num_connected": "(%{numDevices} connessi)",
    "available": "Disponibile",
    "inProgress": "In corso",
    "time_a_m": "del mattino",
    "time_p_m": "del pomeriggio\/della sera",
    "last_synced": "Ultima sincronizzazione",
    "last_synced_lc": "ultima sincronizzazione",
    "no_connected_devices": "Nessun dispositivo connesso",
    "apps_devices_confirm_disconnect": "Sei sicuro di volerti disconnettere?",
    "button_delete": "Elimina",
    "button_disconnect": "Disconnessione",
    "button_cancel": "Annulla",
    "button_dismiss": "Rimuovi",
    "ok": "OK",
    "waist_helper_text": "La misura della vita si prende sopra i fianchi, sotto le costole, nel punto più stretto, e stando in piedi. Se non sei sicuro, usa la taglia dei tuoi jeans.",
    "apps_devices_manage": "Gestisci le mie app e i miei dispositivi",
    "my_apps_devices": "Le mie app e i miei dispositivi",
    "completeRegistration": "Registrazione completa",
    "havingTrouble": "Hai problemi?",
    "contactUs": "Contatta support@sproutatwork.com per ricevere assistenza",
    "done": "Fine",
    "brand": "Sprout",
    "cannotTrackTitle": "Impossibile registrare l'attività",
    "cannotTrackPrior": "Ehi, tu. Le attività possono essere registrate solo dopo la data di inizio.",
    "cannotTrackFuture": "Non così in fretta. Le attività possono essere registrate solo fino al giorno corrente.",
    "cannotTrack": "Le attività non possono essere registrate prima di una data di inizio o per un giorno futuro.",
    "disclaimer": "Esclusione della responsabilità",
    "acceptTerms": "Accetto i termini e le condizioni",
    "verificationEmailTitle": "Verifica la tua e-mail",
    "email_not_yet_verified": "Sembra che tu non abbia ancora verificato il tuo indirizzo e-mail.",
    "email_successfully_verified_title": "Benvenuto",
    "email_successfully_verified": "La tua e-mail è stata verificata con successo",
    "pleaseVerifyEmailMessage1": "Per continuare è necessario verificare il tuo indirizzo e-mail.",
    "pleaseVerifyEmailMessage2": "Segui le istruzioni inviate a:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Rinvia e-mail",
    "restart": "Torna al login",
    "firstName": "Nome di battesimo",
    "firstNamePlaceholder": "Il tuo nome di battesimo",
    "lastName": "Cognome",
    "lastNamePlaceholder": "Il tuo cognome",
    "email": "E-mail",
    "emailPlaceholder": "Il tuo indirizzo e-mail",
    "employeId": "ID dipendente",
    "employeIdPlaceholder": "ID dipendente dell'azienda",
    "passwordPlaceholder": "Nuova password",
    "datePickerTitle": "Seleziona la tua data di nascita",
    "datePickerConfirm": "Conferma",
    "datePickerCancel": "Annulla",
    "termsOfUsePrivacyPreLinks": "Accetto il",
    "sendMePromoCommunications": "Inviami comunicazioni promozionali",
    "sendMePromoCommunicationsFromPartners": "Inviami comunicazioni promozionali dai partner",
    "termsOfService": "Termini di servizio",
    "legal": "Legale",
    "privacyPolicy": "Informativa sulla privacy",
    "and": "e",
    "programDomainLabel": "Nome del programma",
    "programDomainPlaceholder": "Nome del programma",
    "findProgramName": "Trova il nome del mio programma",
    "findProgramNameButton": "Trova il nome del programma",
    "findProgramNameTitle": "Trova il nome del mio programma",
    "findProgramNameDescription": "Indirizzo e-mail dell'azienda",
    "findProgramNamePlaceholder": "Indirizzo e-mail",
    "findProgramSuccessMessage": "I risultati della ricerca del nome del programma sono stati inviati tramite e-mail.",
    "findProgramSuccessTitle": "Nome del programma",
    "findProgramErrorTitle": "Nome del programma",
    "findProgramErrorMessage": "Ops, c'è stato un problema Si è verificato un errore durante il tentativo di recupero del nome del programma. Riprova.",
    "countryLabel": "Seleziona Paese",
    "countryName": "Paese",
    "regionLabel": "Seleziona regione",
    "regionName": "Regione",
    "cityLabel": "Seleziona città",
    "cityName": "Città",
    "locationWorkLabel": "Seleziona sede",
    "locationWorkName": "Sede",
    "locationLabel": "Seleziona sede",
    "locationName": "Sede",
    "departmentLabel": "Seleziona dipartimento\/divisione",
    "departmentName": "Dipartimento\/divisione",
    "no_department": "Nessun\/a dipartimento\/divisione",
    "enterPIN": "Inserisci il PIN della tua azienda",
    "verifyEmailTitle": "Verifica e-mail",
    "verifyEmailMsg": "Sembra che tu non abbia ancora verificato il tuo indirizzo e-mail",
    "resendEmailTitle": "Verifica e-mail",
    "resendEmailMsg": "Rinviato a %{userEmail}",
    "select_date": "Seleziona una data",
    "changePasswordTitle": "Modifica password",
    "currentPassword": "Password attuale",
    "newPassword": "Nuova password",
    "confirmNewPassword": "Conferma la nuova password",
    "passwordChangeError": {
        "currentPasswordMissing": "Inserisci la password attuale",
        "newPasswordMissing": "Inserisci la nuova password",
        "confirmPasswordMissing": "Conferma la tua nuova password",
        "passwordsMatch": "Le password non corrispondono",
        "passwordIncorrect": "Password errata. Riprova."
    },
    "settings": "Impostazioni",
    "signOut": "Esci",
    "updateApp": "Aggiorna app",
    "updateAppRight": "Corrente: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Chiedi aiuto",
    "feedback": "Feedback",
    "feedback_success_title": "Feedback inviato",
    "feedback_success_msg": "Grazie per averci inviato il tuo feedback, lo apprezziamo molto!",
    "feedback_failure_title": "Errore",
    "feedback_failure_msg": "Che peccato... Si è verificato un errore nell'invio del feedback, riprova.",
    "submit": "Invia",
    "feedback_char_limit": "Hai superato il limite di caratteri.",
    "feedback_char_limit_toast_title": "Messaggio troppo lungo",
    "feedback_char_limit_toast_msg": "Il tuo messaggio supera il limite massimo di 2000 caratteri.",
    "feedback_char_length_msg_1": "Hai digitato",
    "feedback_char_length_msg_2": "\/2000 caratteri.",
    "feedback_empty_toast_title": "Messaggio vuoto",
    "feedback_empty_toast_msg": "Sembra che tu non abbia ancora digitato nulla. Digita un messaggio prima di inviarlo.",
    "feedback_email_message": "Messaggio:",
    "feedback_email_user_id": ", ID utente:",
    "feedback_email_device": ", Dispositivo:",
    "feedback_email_os_version": ", Versione del sistema operativo:",
    "feedback_email_app_version": ", Versione dell'app:",
    "savingUserToast": {
        "success": {
            "title": "Salva modifiche",
            "message": "Modifiche al profilo salvate"
        },
        "danger": {
            "title": "Errore riscontrato",
            "message": "Ops... Si è verificato un errore nel tentativo di salvare le tue modifiche, riprova."
        }
    },
    "edit_profile_user_error_msg": "Controlla gli errori prima di cercare di salvare le modifiche",
    "edit_profile_location_error": "Devi specificare la tua sede",
    "edit_profile_department_error": "Devi specificare il\/la tuo\/a dipartimento\/divisione",
    "edit_profile_unspecified_value": "Devi specificare un valore",
    "edit_profile_value_too_low": "Il valore deve essere superiore a",
    "edit_profile_value_too_high": "Il valore deve essere inferiore a",
    "choose_gender": "Seleziona il sesso",
    "activity_tracked_successfuly": "La tua attività è in fase di registrazione",
    "multi_activity_tracked_successfully": "Le tue attività sono in fase di registrazione",
    "no_activities_tracked": "Nessuna attività registrata",
    "track_activity_to_submit": "Scegli una data sul calendario per registrare un'attività.",
    "last_day": "Ultimo",
    "days_remaining": "giorni rimasti",
    "day_remaining": "giorno rimasto",
    "days_remaining_this_week": "giorni rimasti questa settimana",
    "day_remaining_this_week": "giorno rimasto questa settimana",
    "days_remaining_this_month": "giorni rimasti questo mese",
    "day_remaining_this_month": "giorno rimasto questo mese",
    "earned_today": "Guadagnato oggi",
    "earned_this_week": "Guadagnato questa settimana",
    "earned_this_month": "Guadagnato questo mese",
    "earned_in_total": "Guadagnato in totale",
    "goal_completed": "Obiettivo completato,",
    "see_results": "vedi i risultati",
    "pts": "%{customPoints}",
    "of": "di",
    "daily_goal": "Obiettivo giornaliero",
    "weekly_goal": "Obiettivo settimanale",
    "monthly_goal": "Obiettivo mensile",
    "total_goal": "Obiettivo totale",
    "weeks": "settimane",
    "today": "Oggi",
    "this_week": "Questa settimana",
    "this_month": "Questo mese",
    "overall": "Complessivo",
    "level": "Livello",
    "days_remaining_in_period": "%{remainingDays} giorni rimasti",
    "days_left_in_period": "%{remainingDays} giorni rimasti per registrare",
    "pointsToLevel": "Progressi per raggiungere il %{levelName}",
    "levelCompleted": "%{levelName} completato",
    "keepTrackingUntil": "Continua a registrare fino a",
    "activityLevelTitle": "Il mio livello di attività",
    "activityLevelDescription": "Quanto tempo trascorri in una settimana tipo a essere almeno moderatamente attivo, ovvero a lavorare abbastanza duramente da aumentare la frequenza cardiaca e sudare?",
    "activityLevelUnder60": "Meno di 60 minuti",
    "activityLevelUnder150": "Da 60 a 150 minuti",
    "activityLevelOver150": "Oltre 150 minuti",
    "gender_male": "Uomo",
    "gender_female": "Donna",
    "gender_rather_not_say": "Preferisco non rispondere",
    "date_of_birth": "Data di nascita",
    "height": "Altezza",
    "Height": "Altezza",
    "weight": "Peso",
    "waistCircumference": "Circonferenza vita",
    "bloodPressureHg": "Pressione arteriosa sistolica",
    "bloodPressureMm": "Pressione arteriosa diastolica",
    "bloodCholesterol": "Colesterolo totale nel sangue",
    "ldl": "Lipoproteine a bassa densità (LDL)",
    "hdl": "Lipoproteine ad alta densità (HDL)",
    "restingHeartRate": "Frequenza cardiaca a riposo",
    "percentageBodyFat": "Percentuale di grasso corporeo",
    "hipCircumference": "Circonferenza dell'anca",
    "bloodGlucose": "Glicemia",
    "triglycerides": "Trigliceridi",
    "error_401_signed_out_message": "La sessione è scaduta. Effettua nuovamente il login.",
    "first_name": "Nome di battesimo",
    "last_name": "Cognome",
    "preferred_name": "Nome preferito",
    "notifications": "Notifiche",
    "notificationsMarkAllReadButton": "Contrassegna tutte le notifiche come lette",
    "notificationsSettingsButton": "Impostazioni",
    "notificationsSettingsTitle": "Notifiche ed e-mail",
    "notificationEmptyMessage": "Sei aggiornato con le tue notifiche",
    "priorityModalTitle": "Le mie notifiche prioritarie",
    "remindMeLater": "Ricordami più tardi",
    "priorityAdminTitle": "Notifica dal tuo amministratore",
    "markAsRead": "Contrassegna come letto",
    "expand": "Tocca per allargare",
    "collapse": "Tocca per comprimere",
    "takePhoto": "Scatta una nuova foto",
    "choosePhoto": "Scegli una foto",
    "deletePhoto": "Elimina foto",
    "profileImageChangeErrorTitle": "Errore riscontrato",
    "profileImageChangeErrorMessage": "Ops... Qualcosa è andato storto nella modifica della tua foto. Riprova.",
    "editProfile": "Modifica profilo",
    "postButton": "Pubblica",
    "shareYourDayName": "Cosa stai facendo?",
    "greeting": "Ciao, %{firstNameDisplay}!",
    "shareAnUpdate": "Cosa stai facendo?",
    "shareYourDaySubtitle": "Cosa stai facendo?",
    "shareAPost": "Condividi un post",
    "postVisibleTo": "Visibile a",
    "link": "Link",
    "photo": "Foto",
    "insertLink": "Aggiungi un link al tuo post",
    "save": "Salva",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Devi aggiungere contenuti al tuo post prima di inviarlo.",
    "generalErrorTitle": "Post vuoto",
    "generalSuccessTitle": "Successo",
    "simplePlaceholder": "Cosa stai facendo?",
    "likesCountLabel": "Pollici in su",
    "likesReceivedLabel": "Pollici in su ricevuti",
    "commentsCountLabel": "Commenti",
    "commentsCountLabelSingular": "Commento",
    "likeButton": "Pollici in su",
    "commentButton": "Commento",
    "seePreviousComments": "Vedi commenti precedenti",
    "addCommentPlaceholder": "Aggiungi un commento",
    "postCommentButton": "Pubblica",
    "seeMoreLongComment": "Vedi di più",
    "activityPoints": "%{customPoints}",
    "activityLog": "Registro delle attività",
    "discardPost": "Cancella",
    "discardPostMessage": "Sei sicuro di voler cancellare il tuo post?",
    "stream_filter_title": "Stream",
    "stream_filter_screen_desc": "Seleziona i post che desideri visualizzare nello stream.",
    "stream_filter_selection": "Mostra:",
    "moderate": "Contrassegna come inappropriato",
    "moderateDescription": "Contrassegnando questo elemento come inappropriato, lo si rimuoverà e un amministratore ne verrà informato.",
    "editPost": "Modifica post",
    "deletePost": "Cancella post",
    "deleteComment": "Cancella commento",
    "editComment": "Modifica commento",
    "visibleOnlyToMe": "Visibile solo a me",
    "joinEvent": "È gradita conferma per l'evento",
    "joinEventDetail": "Partecipa all'evento",
    "joinedEvent": "Corro!",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Ti sei iscritto all'evento",
            "message": "Iscrizione a questo evento andata a buon fine"
        }
    },
    "joinChallenge": "Partecipa alla sfida",
    "viewChallenge": "Visualizza la sfida",
    "joinedChallenge": "Iscrizione alla sfida riuscita",
    "joinCommunity": "Entra nella community",
    "joinedCommunity": "Iscrizione alla community riuscita",
    "joinProgress": "Iscrizione in corso",
    "joinSuccess": "Iscritto",
    "invitePeopleToCommunity": "Invita le persone alla community",
    "numberOfMembers": "%{num} membri",
    "joinToView": "Iscriviti a questa community per visualizzare e inviare post ad altri membri",
    "numberOfAttendees": "%{num} iscritto\/i",
    "numberOfParticipants": "%{num} partecipanti",
    "numberOfMembersWithUser": "Tu e %{num} altro\/i membro\/i",
    "numberOfAttendeesWithUser": "Tu e %{num} altro\/i iscritto\/i",
    "numberOfParticipantsWithUser": "Tu e %{num} altro\/i partecipante\/i",
    "communityMembers": "%{numberOfMembers} membro\/i",
    "communityEvents": "%{numberOfEvents} evento imminente",
    "myEvents": "I miei eventi",
    "seeAll": "Vedi tutto",
    "noUpcomingEvents": "Non ci sono eventi imminenti. Partecipiamo a un evento!",
    "myCommunities": "Le mie community",
    "invitedCommunities": "Invitato",
    "invitationSendingMessage": "Invio di inviti in corso",
    "invitationReceivedMessage": "ti ha invitato a unirti a questa",
    "invitationMessage": "Ci piacerebbe averti nella nostra community!",
    "recommendedCommunities": "Consigliato per te",
    "leaveCommunity": "Abbandona questa community",
    "leaveTeam": "Sei sicuro di voler abbandonare la squadra",
    "leaveTeamLastMember": "in questa sfida? In qualità di ultimo membro della squadra, abbandonare la sfida comporterà l'eliminazione della squadra.",
    "leaveTeamChallenge": "in questa sfida?",
    "Oops": "Ops, qualcosa è andato storto",
    "editCommunity": "Modifica community",
    "deleteCommunity": "Cancella questa community",
    "leaveCommunityDescription": "Sei sicuro di voler abbandonare questa community?",
    "inviteToCommunity": "Invito alla community",
    "inviteByMembers": "Invito tramite nome",
    "inviteByEmail": "Invito tramite e-mail",
    "select_person": "Seleziona almeno una persona da invitare",
    "no_users_found": "Non riusciamo a trovare nessuno con questo nome.",
    "promptJoinCommunities": "Sembra che tu non si sia iscritto a nessuna community. Unisciti alle community per confrontarti con gli altri e condividere il tuo viaggio.",
    "exploreCommunities": "Scopri le community",
    "sendInviteByMembers": "Invita %{num} persone",
    "sendInviteByEmail": "Invita tramite e-mail",
    "createNewCommunity": "Crea una nuova community",
    "createCommunity": "Crea una community",
    "uploadCover": "Aggiungi una foto",
    "cover": "Copertina",
    "nameOfCommunity": "Nome della community",
    "whatCommunityAbout": "Di cosa tratta questa community?",
    "companyMembersOnly": "Solo per i membri dell'azienda",
    "viewAllButton": "Visualizza tutto",
    "communities": "Community",
    "contentLibrary": "Libreria",
    "events": "Eventi",
    "past_events": "Eventi passati",
    "invitationCommunity": "community",
    "searchPeople": "Cerca persone",
    "enterEmail": "Inserisci e-mail",
    "personalMessageToNewInvitees": "Messaggio personale ai nuovi invitati",
    "dangerToastTitle": "Errore",
    "dangerToastMessage": "Ehm... Qualcosa è andato storto. Riprova.",
    "successToastTitle": "Successo",
    "successToastMessage": "Azione completata",
    "joiningToast": {
        "success": {
            "message": "Ti sei unito a"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Commento cancellato"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Commento contrassegnato come inappropriato"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Commento aggiornato"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Commento aggiornato"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Foto del profilo aggiornata"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Foto del profilo eliminata"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Invia allo stream",
            "message": "Il tuo post è stato creato"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Modifica post",
            "message": "Il tuo post è stato modificato"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Cancella post",
            "message": "Il tuo post è stato cancellato"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Contrassegna come inappropriato",
            "message": "Post contrassegnato come inappropriato"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Contrassegna come letto",
            "message": "Tutte le notifiche contrassegnate come lette"
        },
        "info": {
            "title": "Contrassegna come letto",
            "message": "Tutte le notifiche sono già state contrassegnate come lette."
        },
        "danger": {
            "title": "Contrassegna come letto"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Impossibile contrassegnare la notifica come letta"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Password aggiornata",
            "message": "Accedi con la tua nuova password"
        },
        "danger": {
            "title": "Aggiorna la password",
            "message": "Ops... Qualcosa è andato storto quando abbiamo cercato di aggiornare la tua password. Riprova."
        }
    },
    "joining": {
        "success": {
            "message": "Ti sei unito a %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Inviti",
            "message": "L'invito\/gli inviti è\/sono stato\/i inviato\/i"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Crea una community",
            "message": "La tua nuova community è stata creata"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Il tuo obiettivo è stato riavviato"
        },
        "danger": {
            "message": "Impossibile riavviare l'obiettivo"
        }
    },
    "quit": "Abbandona",
    "wellbeing_survey_completed": "Sondaggio sul benessere completato",
    "wellbeing_survey_completed_message": "Grazie per aver completato il sondaggio. Ci auguriamo che questo ti abbia aiutato a comprendere meglio il tuo stato di salute.",
    "update_wellbeing_score": "Aggiorna le mie risposte al sondaggio",
    "get_wellbeing_score": "Ottieni il tuo punteggio Benessere",
    "stats": "Statistiche",
    "my_wellbeing_score": "Il mio punteggio Benessere",
    "see_details": "Vedi dettagli",
    "how_score_calculated": "Come viene calcolato il mio punteggio?",
    "contentTitle": "Libreria",
    "promoted": "In primo piano",
    "recommended": "Consigliato",
    "recommendedForMe": "Consigliato per me",
    "recent": "Aggiunto di recente",
    "view": "Visualizza",
    "added": "Aggiunto",
    "more": "altro",
    "openLibrary": "Portami alla libreria",
    "readToEarn": "Leggi per guadagnare",
    "readArticle": "Apri link",
    "see_more": "Vedi altri (%{num})",
    "see_more_activities": "%{num} in più",
    "my_achievements": "I miei traguardi",
    "achievements": "Traguardi",
    "achievement_earned_date": "Guadagnato: %{date}",
    "achievement_start_date": "Iniziato: %{date}",
    "achievement_end_date": "Termina: %{date}",
    "achievement_earned": "Guadagnato",
    "achievement_start": "Inizia",
    "achievement_end": "Termina",
    "achievement_earned_times": "%{num} volte",
    "achievement_earned_time": "%{num} volta",
    "in_progress": "In corso",
    "date_earned": "Data di conseguimento",
    "earned": "Guadagnato",
    "past_dates_earned_heading": "guadagnato in passato",
    "all": "Tutto",
    "eat": "Mangiare",
    "move": "Movimento",
    "feel": "Benessere",
    "profile_completion": "Completamento del profilo: %{percentage}%",
    "complete_my_profile": "Completa il tuo profilo",
    "do_following_tasks": "Esegui il\/i seguente\/i %{num} compito\/i per completare il tuo profilo.",
    "improve_my_score": "Migliora il tuo punteggio",
    "see_which_goals": "Verifica gli obiettivi che ti sei posto per mangiare, fare movimento e sentirti meglio.",
    "havent_set_goal": "Non hai ancora fissato un obiettivo.",
    "set_a_goal": "Fissa un obiettivo",
    "set_another_goal": "Fissa un altro obiettivo",
    "set_another_goal_here": "Fissa qui un altro obiettivo.",
    "my_recently_tracked_activities": "Le mie attività recenti",
    "a_few_seconds_ago": "pochi secondi fa",
    "a_day_ago": "un giorno fa",
    "yesterday": "Ieri",
    "earn": "Guadagna",
    "delete_activity_confirmation": "Sei sicuro di voler rimuovere questa attività?",
    "delete_activity_title": "Vuoi rimuovere %{measurement} di %{activity_name}?",
    "reached_daily_goal": "Oggi hai raggiunto il tuo obiettivo. Ben fatto!",
    "multiple_activity_non_daily_instruction": "Tocca una riga attività per iniziare a registrare e guadagnare %{customPoints}!",
    "multiple_activity_daily_instruction": "Tocca il segno più per registrare la quantità di attività necessaria per raggiungere il tuo obiettivo. Tocca un qualsiasi altro punto della riga attività per registrare la quantità di quell'attività.",
    "only_automatic_activities": "Le attività che contribuiscono al raggiungimento di questo obiettivo possono essere registrate solo automaticamente",
    "only_automatic_activity": "L'attività che contribuisce al raggiungimento di questo obiettivo può essere registrata solo automaticamente",
    "earn_pts_and_reach_goal": "Guadagna %{pts} punti e raggiungi il tuo obiettivo registrando %{qty}",
    "earn_pts_for_every": "Guadagna %{pts} punti per ogni",
    "you_track": "registrato!",
    "you_have_tracked": "Hai registrato %{qty}",
    "so_far": "finora!",
    "start_goal": "Fissa questo obiettivo",
    "about_this_goal": "Informazioni su questo obiettivo",
    "start_date": "Data di inizio",
    "end_date": "Data di fine",
    "activities": "Attività",
    "goal": "Obiettivo",
    "instructions": "Istruzioni",
    "daily": "Quotidianamente",
    "weekly": "Settimanalmente",
    "monthly": "Mensilmente",
    "total": "Totale",
    "week": "Settimana",
    "day": "Giorno",
    "days": "Giorni",
    "month": "Mese",
    "months": "Mesi",
    "progress": "Progressi",
    "about": "Informazioni",
    "days_remaining_to_track": "Hai a disposizione %{num} giorni per registrare le attività mancate",
    "number_days": "%{num} giorni",
    "one_day": "1 giorno",
    "points_earned_this_week": "Punti guadagnati questa settimana",
    "points_earned_year": "Punti guadagnati dall'inizio dell'anno fino a oggi",
    "completed": "Completata",
    "what_you_need_to_do": "Cosa devi fare",
    "see_all_num": "Vedi tutti %{num}",
    "my_week_progress": "I tuoi progressi settimanali",
    "my_day_progress": "I tuoi progressi quotidiani",
    "my_month_progress": "I tuoi progressi mensili",
    "my_total_progress": "I tuoi progressi totali",
    "my_overall_progress": "Progressi complessivi",
    "you_earned": "Hai guadagnato",
    "of_this_week": "di %{num} questa settimana",
    "of_this_day": "di %{num} oggi",
    "of_this_month": "di %{num} questo mese",
    "of_this_total": "di %{num} in totale",
    "of_this_overall": "di %{num} complessivamente",
    "remaining_this_week": "rimasti questa settimana",
    "remaining_this_month": "rimasti questo mese",
    "remaining_this_total": "rimasto",
    "remaining_this_overall": "complessivi rimasti",
    "view_history": "Visualizza cronologia",
    "this_goal_is": "Questo obiettivo è",
    "will_run_for": "Si candiderà per",
    "button_unset_goal": "Obiettivo non raggiunto",
    "button_leave_challenge": "Abbandona la sfida",
    "leaveChallenge": {
        "menu": "Abbandona %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Elimina %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Hai annullato questo obiettivo personale."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Hai abbandonato la sfida."
        }
    },
    "activities_tracked": "Attività registrate",
    "recently_tracked_activities": "Attività registrate di recente",
    "add": "Aggiungi",
    "change_before_track": "Sembra che tu non abbia apportato alcuna modifica. Modifica la quantità di attività per questo giorno o esci senza apportare modifiche.",
    "havent_tracked_today": "Sembra che non sia stata ancora rilevata alcuna attività per questo giorno. Inizia a cercare un'attività.",
    "cancel_tracking_quantity": "Annulla la registrazione %{quantity} di %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Uscendo si cancelleranno le modifiche alla cronologia delle tue attività. Sei sicuro?",
    "discard_activity_edits_confirmation_date": "Uscendo si cancelleranno le modifiche alla cronologia delle tue attività per %{date}. Sei sicuro?",
    "yes_discard_edits": "Sì, esci e cancella le modifiche",
    "createGoal": {
        "navigatorTitle": "Crea un obiettivo personale",
        "navigatorSubtitle": "Fase %{step} di 4"
    },
    "allCommunities": "Tutto",
    "deleteCommunityDescription": "Sei sicuro di voler eliminare questa community?",
    "remaining": "rimasto",
    "recommended_goal": "Obiettivo consigliato",
    "pinError": "Il PIN %{pin} non è valido. Riprova.",
    "previousPersonalGoals": "I miei obiettivi personali raggiunti",
    "previousGoalsTitle": "I miei obiettivi passati",
    "endedOn": "si è conclusa il",
    "achievedOfGoal": "Hai raggiunto %{num}% dell'obiettivo",
    "previousGoalsEmptyMessage": "Non hai obiettivi passati",
    "emptyListDefaultMessage": "Non hai elementi qui",
    "myCommunitiesEmpty": "Sembra che tu non si sia iscritto a nessuna community. Unisciti alle community per confrontarti con gli altri e condividere il tuo viaggio.",
    "discoverMoreCommunities": "Scopri altre community",
    "howLong": "Durata",
    "frequency": "Frequenza",
    "discard": "Cancella",
    "description": "Descrizione",
    "optional": "facoltativo",
    "instruction": "Istruzioni",
    "name": "Nome",
    "create": "Crea",
    "categories": "Categorie",
    "uploadPhoto": "Aggiungi una foto",
    "delete_goal": "Cancella questo %{name}",
    "delete_goal_confirmation": "Sei sicuro di voler eliminare questo obiettivo?",
    "leave_goal_confirmation": "Sei sicuro di voler abbandonare questa sfida?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Il tuo obiettivo è stato creato."
        }
    },
    "defaultSelectMessage": "Seleziona un'opzione",
    "search": "Cerca",
    "inTotal": "in totale",
    "State": "Stato",
    "Business unit": "Unità aziendale",
    "Work location": "Sede di lavoro",
    "whenStart": "Quando vuoi iniziare?",
    "every": "ogni",
    "acceptChallenge": "Accetta la sfida",
    "activity_history_challenge": "Cronologia delle attività per la sfida",
    "havent_tracked_challenge": "Non hai registrato alcuna attività per questa sfida.",
    "earned_lowercase": "guadagnato",
    "noone_tracked_yet": "Nessuno ha ancora registrato nulla. Inizia a registrare per essere in testa in questa competizione!",
    "you": "Tu",
    "your_team": "La mia squadra",
    "congrats_first_place": "Congratulazioni, sei al primo posto! Continua così, ottimo lavoro!",
    "leader": "Leader",
    "average": "Media",
    "show_leader": "Mostra leader",
    "show_me": "Mostrami",
    "show_my_team": "Mostra la mia squadra",
    "leaderboard": "Classifica",
    "my_team": "La mia squadra",
    "remaining_to_track": "rimasti da registrare",
    "avg": "media",
    "invite": "Invita",
    "team_members": "Membri della squadra",
    "daysLeft": "Giorni rimasti",
    "regionNameLiveBetter": "Stato",
    "locationNameLiveBetter": "Sede di lavoro",
    "departmentNameLiveBetter": "Unità aziendale",
    "regionLabelLiveBetter": "Seleziona stato",
    "locationLabelLiveBetter": "Seleziona sede di lavoro",
    "departmentLabelLiveBetter": "Seleziona unità aziendale",
    "companyLocation": "Sede di lavoro",
    "no_location": "Nessuna sede",
    "connect": "Collega",
    "syncing": "Sincronizzazione in corso",
    "sync": "Sincronizza",
    "havent_tracked_in_a_while": "Nessuna attività registrata di recente",
    "contact": "Contatta",
    "manage": "Gestisci",
    "creator": "Creatore",
    "allow_notifications": "Gestisci notifiche",
    "enable_notifications": "Attiva le notifiche",
    "appload": "Aspetta un attimo mentre {app_name} si aggiorna",
    "sendResetEmail": "Invia un'e-mail di reimpostazione",
    "min": "Min",
    "max": "Max",
    "error_joining_team": "Impossibile unirsi alla squadra",
    "cannot_add_to_team": "Ops... Qualcosa è andato storto quando abbiamo cercato di aggiungerti a questa squadra. È possibile che la squadra abbia raggiunto il numero massimo di membri o che non esista più. Se si è verificato un altro errore, riprova.",
    "members_needed": "%{num} membri necessari",
    "member_needed": "%{num} membro necessario",
    "spots_left": "%{num} posti rimasti",
    "join": "Partecipa",
    "no_teams_create": "Al momento non ci sono squadre a cui iscriverti. Perché non ne crei una tu?",
    "number_teams": "%{num} squadre",
    "youLowercase": "tu",
    "joined_challenge_on_team": "Ti sei iscritto a una sfida nella squadra %{team_name}.",
    "join_team": "Unisciti a una squadra",
    "former_members": "Ex membri",
    "letsGo": "Andiamo",
    "invite_to_team": "Invito alla squadra",
    "connectingDeviceToast": {
        "success": {
            "title": "Connetti un'app o un dispositivo",
            "message": "Successo! L'app o il dispositivo sono connessi."
        },
        "danger": {
            "title": "Connetti un'app o un dispositivo",
            "message": "Ops... Abbiamo avuto un problema di connessione a questo servizio. Riprova."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Disconnetti un'app o un dispositivo",
            "message": "La disconnessione di %{name} è avvenuta con successo."
        },
        "danger": {
            "title": "Disconnetti un'app o un dispositivo",
            "message": "Ops... Abbiamo avuto un problema nel disconnettere %{name}. Riprova."
        }
    },
    "leave_entity_question": "Vuoi abbandonare %{name}?",
    "delete_entity_question": "Vuoi eliminare %{name}?",
    "leave_team_challenge_confirmation": "Sei sicuro di voler abbandonare %{name} in questa sfida?",
    "leave_last_team_member": "In quanto ultimo membro della squadra, abbandonare questa sfida comporterà l'eliminazione della squadra stessa.",
    "oops_msg": "Ops... Si è verificato un errore nel tentativo di completare questa azione. Riprova.",
    "has_been_created": "Ti sei unito alla sfida nella squadra %{name}.",
    "specify_team_name": "Specifica il nome della squadra",
    "invite_members": "Invita i membri",
    "upload_photo_no_question": "Aggiungi una foto",
    "my_progress": "I miei progressi",
    "rewardsPointsAdditionalInfo": "Guadagna %{reward_currency} per ciascun livello raggiunto ogni %{period}. I tuoi %{customPoints} e i tuoi livelli ricominciano ogni %{period}, quindi hai la possibilità di continuare a guadagnare %{reward_currency} anche se hai raggiunto il livello più alto nell'ultimo periodo.",
    "rewardsPointsInfo": "I tuoi %{customPoints} e i progressi si azzerano ogni %{period}.",
    "departments": "Dipartimenti\/Divisioni",
    "regions": "Regioni",
    "noItemsSelected": "Nessuna voce selezionata",
    "pleaseSelectOne": "Seleziona almeno una voce dall'elenco",
    "tracked": "Registrato",
    "starts": "Inizia",
    "duration": "Durata",
    "bonus": "Bonus",
    "invited_by": "Invitato da",
    "create_team": "Crea una squadra",
    "discardConfirmation": "Sei sicuro di voler uscire?",
    "discardYes": "Sì",
    "discardStay": "Torna indietro",
    "create_team_toast_title": "Crea una squadra",
    "edit_team": "Modifica squadra",
    "team_edits_submitted": "La tua squadra è stata aggiornata.",
    "challenge_ended_still_trackable": "Questo %{type} è terminato, fortunatamente hai ancora %{num} giorni per registrare!",
    "tracking_period_ended": "Il periodo di registrazione per questo %{type} è terminato.",
    "unlimited": "Illimitato",
    "ends_in": "Termina tra",
    "challenge_toast": {
        "success": {
            "join": "Successo!",
            "message": "Iscrizione alla sfida riuscita."
        },
        "danger": {
            "error": "Errore",
            "message": "Qualcosa è andato storto. Riprova a partecipare alla sfida tra un po'."
        }
    },
    "members_to_invite": "Membri da invitare",
    "members_to_remove": "Membri da rimuovere",
    "myChallenges": "Competizioni",
    "upcoming": "Imminente",
    "myPersonalGoals": "Obiettivi",
    "companyCompetitions": "Concorsi aziendali",
    "communityCompetitions": "Competizioni della community",
    "edit_your_team": "Modifica la tua squadra",
    "emails": "E-mail",
    "CompletedOverall": "Completato complessivamente",
    "TotalEarned": "Totale guadagnato",
    "notify_header": "Desidero essere informato:",
    "AdditionalBonus": "Bonus aggiuntivo",
    "goalEndedNotification": "Obiettivo raggiunto, continua a spronare te stesso!",
    "compEndedNotification": "La competizione è terminata, continua a spronare te stesso!",
    "congrats_tracking_first": "Congratulazioni per aver registrato la tua prima attività!",
    "keep_tracking": "Continua a registrare la tua attività per raggiungere gli obiettivi e salire di livello.",
    "understanding_tracking": "Informazioni sulla registrazione",
    "cannot_track_this_day": "Non puoi registrare per questo giorno.",
    "nothing_tracked_this_day": "Non hai ancora registrato per questo giorno.",
    "tracked_something_this_day": "Hai registrato qualcosa per questo giorno.",
    "reached_goal_this_day": "Hai raggiunto il tuo obiettivo per questo giorno (solo per gli obiettivi giornalieri).",
    "got_it": "Capito!",
    "notDismissedMultiTitle": "Riassunto della sfida",
    "notDismissedMultiSubtitle": "Alcune sfide si sono concluse. Per i dettagli sulla tua prestazione, dai uno sguardo più approfondito a ciascuna di esse.",
    "daySummary": "%{userName}, ecco un riassunto della tua giornata fino ad ora",
    "goals": "Obiettivi",
    "competitions": "Competizioni",
    "totalAccumulated": "Totale accumulato",
    "tracking_for_date": "Registrazione per %{date} in corso",
    "activity_tracker_instruction": "Tocca per modificare o rimuovere un'attività registrata manualmente.",
    "ended": "Terminato",
    "notYetAvailableBeta": "Non ancora disponibile in versione beta",
    "suggestedGoal": "Obiettivo suggerito",
    "singleFor": "per",
    "seeLessLongComment": "Vedi di meno",
    "synced_data": "Dati sincronizzati:",
    "doThisLater": "Lo farò più tardi",
    "inviteUsers": "Invita altri a partecipare",
    "cannotTrackAfterDeadline": "Stai cercando di registrare un'attività per una data successiva al termine della sfida.",
    "potentialBonusPoints": {
        "section": {
            "title": "Per questo obiettivo sono disponibili %{potentialBonusPoints} bonus %{customPoints}!",
            "titleNotCompleted": "Hai mancato %{potentialBonusPoints} bonus %{customPoints} per %{activitytCompletedPercentage}%.",
            "titleCompleted": "Congratulazioni! Hai guadagnato",
            "titleCompletedBold": "%{potentialBonusPoints} bonus %{customPoints}!",
            "subtitle": "Per saperne di più sul bonus %{customPoints}"
        },
        "modal": {
            "title": "Bonus %{customPoints}",
            "desc1": "Sappiamo che nessuno è perfetto e non può portare a termine i propri obiettivi il 100% delle volte.",
            "desc2": "Ecco perché assegniamo bonus %{customPoints} quando i progressi complessivi sono pari o superiori all'85%.",
            "desc3": "Tutti i bonus %{customPoints} vengono assegnati a completamento dell'obiettivo e se tutte le registrazioni sono state effettuate da un'app o da un dispositivo connessi riceverai bonus %{customPoints} doppi!",
            "desc4": "Non riceverai bonus %{customPoints} per gli obiettivi che hai abbandonato prima di completarli."
        },
        "msg": {
            "title": "Questo obiettivo è terminato",
            "subtitle": "L'obiettivo è terminato il %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Tempo scaduto! Il tuo obiettivo è terminato",
            "subtitle": "Hai a disposizione %{daysNum} %{daysOrDay} per registrare la tua attività."
        }
    },
    "finish": "Termina",
    "personalGoal": {
        "all_goals": {
            "selected": "Tutti gli obiettivi %{maxGoals} sono stati raggiunti!",
            "description": "È di tuo gradimento? Puoi sostituire qualsiasi obiettivo se cambi idea. Non preoccuparti, puoi disattivare il tuo obiettivo in un secondo momento.",
            "set": "Tutti gli obiettivi sono stati fissati!",
            "action": "Tutto pronto, si parte!",
            "error": "Non lasciamoci trasportare! Concentrarsi su un massimo di 3 obiettivi strutturati alla volta aumenterà le probabilità di successo.",
            "errorHeading": "Definizione degli obiettivi"
        },
        "set_more": "Puoi fissare più obiettivi %{maxGoals} attivi",
        "select_goal": {
            "heading": "Fissa un obiettivo consigliato o creane uno tuo"
        },
        "set_more_1": "Puoi fissare 1 altro obiettivo attivo"
    },
    "restartPersonalGoal": "Riavvia l'obiettivo con nuovi target",
    "delete_challenge_confirmation": "Sei sicuro di voler eliminare questa sfida?",
    "personal_goal_unit": "obiettivo",
    "personal_goal_units": "obiettivi",
    "day_summary": {
        "steps_taken": "Passi compiuti",
        "calories_in": "Calorie immesse",
        "calories_out": "Calorie consumate",
        "avg_daily": "media giornaliera",
        "most_earned_daily": "guadagnato di più al giorno"
    },
    "invitedBy": "Invitato da %{person}",
    "resetPasswordMissingField": "Inserisci un'e-mail",
    "resetPasswordInvalidValue": "Inserisci un indirizzo e-mail valido",
    "resetPasswordNotFound": "La tua e-mail non è stata trovata",
    "resetPasswordNotCompleted": "Non è stato possibile completare la tua richiesta",
    "resetGoalInstructions": {
        "start": "Esegui %{quantity} %{units} di %{activity}",
        "additional": ", %{quantity} %{units} di %{activity}",
        "end": "%{frequency} e guadagna %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Un obiettivo fissato. Visualizza",
        "two": "Due obiettivi fissati. Visualizza",
        "three": "Tre obiettivi fissati. Visualizza",
        "none": "Non sono stati fissati obiettivi. Fissa gli obiettivi"
    },
    "searchCommunitiesEmpty": "Nessuna community trovata",
    "searchCommunitiesPlaceholder": "Cerca community",
    "updating": "Aggiornamento in corso",
    "pts_tracked": "Registrato %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Continua a lavorare bene, sei sulla buona strada per migliorare il tuo punteggio Benessere.",
    "progressHistory": "Cronologia progressi",
    "privateCommunity": "Questa è una community privata",
    "do_combo_of_activities": "Esegui una qualsiasi combinazione tra le seguenti operazioni.",
    "noActivitiesTracked": "Nessuna attività registrata",
    "trackingWithFollowingApps": "Registrazione con le\/i seguenti app\/dispositivi",
    "recommendedApps": "App\/dispositivi consigliate\/i per questo %{challengeType}",
    "collapseWord": "Comprimi",
    "started": "Iniziato",
    "ends": "Termina",
    "do_activities": "Esegui attività",
    "rewards_placeholder": "Esempio di premi dal negozio, segnaposto. Gli utenti vedranno i vari prodotti che possono acquistare e il relativo costo in %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Principale"
        },
        "allGoals": "Tutti gli obiettivi",
        "seeMoreCard": {
            "heading": "Non trovi ciò che stai cercando?",
            "description": "Dai un'occhiata a tutti gli obiettivi consigliati",
            "button": "Scopri gli obiettivi"
        }
    },
    "rewardsNotAvailable": "I premi non sono attualmente disponibili in questa versione beta. Quando saranno disponibili, potrai visualizzare il catalogo e riscattare.",
    "editProfileProvideRestingHeartRate": "Fornisci un valore valido di frequenza cardiaca a riposo pari ad almeno 40",
    "liveBetterHealthInfo": "Gestiamo una serie di programmi e abbiamo una varietà di contenuti sulla salute ideati per supportare una serie di esigenze sanitarie e aiutarti a raggiungere un migliore stato di salute. Non disponiamo ancora di programmi per ogni condizione ed esigenza di salute - ci stiamo lavorando! - Tuttavia, se risponderai alle seguenti domande, ti contatteremo se individueremo programmi o servizi sanitari a cui potresti partecipare e\/o ti invieremo informazioni basate su dati concreti che ti aiuteranno a comprendere e gestire meglio le tue esigenze di salute. Non utilizziamo queste informazioni per valutare l'adeguatezza della tua polizza. Se desideri scoprire per cosa sei coperto o hai domande sulla tua polizza, puoi chiamare il nostro team Customer Connect al numero 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Hai eliminato l'obiettivo"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Hai eliminato la sfida"
        }
    },
    "invitations": "Inviti",
    "learnMorePeriods": "Scopri di più sui periodi",
    "tracked_by_app_name": "Registrato da %{app_name}",
    "device_required": {
        "text": "Questo %{challengeType} richiede un'app o un dispositivo",
        "button": "Connetti un'app o un dispositivo"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Modifica community",
            "message": "La community è stata modificata"
        }
    },
    "competition": "Competizione",
    "close": "Chiudi",
    "only_automatic_activities_with_device": "Le attività di questo %{goal_or_competition} sono registrate automaticamente con le app\/i dispositivi collegate\/i.",
    "only_automatic_activity_with_device": "L'attività di questo %{goal_or_competition} è registrata automaticamente con le app\/i dispositivi collegate\/i.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Community eliminata"
        }
    },
    "teamSizeMessage": "La tua squadra ha bisogno di almeno %{min} persone per guadagnare %{customPoints} per la sfida.",
    "captain": "Capitano",
    "inviteOthersToTeam": "Invita altri nella mia squadra",
    "loadingMetrics": "Connessione alle fonti in corso per aggiornare la tua giornata",
    "aboutTeamSize": {
        "title": "Numero di membri della squadra",
        "text": "Da %{min} a %{max}"
    },
    "pointsOverview": "Panoramica %{customPoints}",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Non è stato possibile completare la tua richiesta",
        "error": "Errore"
    },
    "required_lc": "richiesto",
    "personal": "Dati personali",
    "biometrics": "Dati biometrici",
    "makeSelection": "Effettua una selezione",
    "ask_question_success_msg": "Grazie. Risponderemo appena possibile.",
    "report_issue_success_msg": "Grazie. Risponderemo appena possibile.",
    "ask_question_success_title": "Domanda inviata",
    "report_issue_success_title": "Problema tecnico inviato",
    "ask_question_failure_msg": "Che peccato... Si è verificato un errore nell'invio della tua domanda, riprova.",
    "report_issue_failure_msg": "Che peccato... Si è verificato un errore nella segnalazione del tuo problema, riprova.",
    "notTrackedActivities": "Non hai registrato alcuna attività per questo periodo.",
    "learn": "Apprendi",
    "Balance": "Saldo",
    "details": "Dettagli",
    "Reward": "Premio",
    "levelsReset": "I livelli si azzerano tra %{remainingDays} giorni",
    "redeem": "Riscatta",
    "redeemAt": "Riscatta a %{points}",
    "needPointsToRedeem": "Ti servono altri %{points} %{rewardName}.",
    "learnEarnMore": "Scopri come guadagnare di più",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Unisciti alla squadra",
            "message": "Sei entrato a far parte della squadra!"
        },
        "danger": {
            "message": "Abbiamo riscontrato un errore e non siamo riusciti a trovare la squadra. Potrebbe non esistere più."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Azione non disponibile",
            "message": "Non è stato possibile completare la tua richiesta."
        }
    },
    "transactionLog": "Transazioni",
    "orderHistory": "Ordini",
    "pointsAvailableToEarn": "%{points} disponibili da guadagnare",
    "missedYTD": "%{missed} mancati dall'inizio dell'anno fino a oggi",
    "rewardsDetails": "Premi",
    "successfullyRedeemedItem": "Hai riscattato con successo questo articolo",
    "orderNumber": "Numero d'ordine",
    "amountSpent": "Importo speso",
    "status": "Stato",
    "dateRedeemed": "Data del riscatto",
    "additionalInformation": "Informazioni aggiuntive",
    "shipToAddress": "Spedisci a questo indirizzo",
    "pointMissedYearToDate": "%{rewardCurrencyName} mancato quest'anno",
    "pointMissedYearToDateDescription": "Se non raggiungi un livello prima della fine del periodo, le %{rewardCurrencyName} associate che avresti potuto guadagnare sono considerate perse.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Articolo non trovato",
            "message": "Impossibile trovare l'articolo. Potrebbe essere stato eliminato o non essere più disponibile."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Community non trovata",
            "message": "Non è stato possibile trovare la community. Potrebbe essere stata eliminata o non essere più disponibile."
        }
    },
    "shippingAddress": "Indirizzo di spedizione\/fatturazione",
    "enterShippingAddress": "Inserisci il tuo indirizzo di spedizione\/fatturazione",
    "streetLine": "Via %{num}",
    "stateProvince": "Stato\/Provincia",
    "postcodePostalcodeZip": "Codice postale\/codice di avviamento postale",
    "phoneNumber": "Numero di telefono",
    "order": "Ordine",
    "redemptionConfirmation": "Conferma del riscatto",
    "edit": "Modifica",
    "processing": "Elaborazione in corso",
    "checkIsYouFirst": "Dobbiamo solo verificare prima che sei tu",
    "discardSomeGoals": "Hai fissato alcuni obiettivi. Questi obiettivi verranno cancellati se proseguirai.",
    "settingGoalsToast": {
        "success": {
            "message": "I tuoi nuovi obiettivi sono stati fissati!"
        }
    },
    "one_team": "1 squadra",
    "noAchievementsToEarnMessage": "Sembra che non ci siano più badge per guadagnare %{rewardCurrencyName} in questo periodo.",
    "shopRewards": "Acquista premi",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Indirizzo di spedizione\/fatturazione",
            "message": "Compila tutti i campi prima di continuare."
        }
    },
    "viewDetails": "Visualizza dettagli",
    "potential": "Potenziale",
    "missed": "Mancato",
    "rewardsStoreNotAvailable": "Il negozio dei premi non è disponibile per te in questo momento.",
    "havent_tracked_in_a_while_date": "Nessuna attività registrata per %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Sfida non trovata",
            "message": "Non è stato possibile trovare una sfida. Potrebbe essere stata eliminata o non essere più disponibile."
        }
    },
    "shareYourDaySubtitleActivity": "Aggiungi una foto o dì qualcosa su questa attività!",
    "goal_ended": "Obiettivo raggiunto",
    "challenge_ended": "Sfida terminata",
    "day_remaining_to_track": "Hai 1 giorno di tempo per registrare eventuali attività mancate",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} si è concluso il %{endDate}",
    "goalEndedModal": {
        "title": "Recupera le attività dimenticate",
        "message": "Al termine di un obiettivo o di una sfida personali, hai tre giorni di tempo dalla data di conclusione per registrare le attività eventualmente dimenticate. Dopo questo periodo di tolleranza, non potrai più registrare altre attività ai fini dell'obiettivo o della sfida."
    },
    "summary": "Sintesi",
    "placedRank": "Ti sei posizionato %{rank} su %{totale}",
    "rank": {
        "first": "1°",
        "second": "2°",
        "third": "3°",
        "n": "%{rank}°"
    },
    "event_name": "Nome evento",
    "this_is": "Questo è un",
    "location_info": "Sede e informazioni",
    "what_event": "Che cos'è questo evento",
    "event_is": "Questo evento è",
    "start_on": "Inizia il:",
    "end_on": "Termina il:",
    "location": "Sede",
    "chooseLeaderboard": "Scegli una classifica",
    "filterOneOfFollowing": "Filtra uno dei seguenti",
    "showChallengeInstead": "Mostra piuttosto una sfida",
    "showActivityInstead": "Mostra piuttosto un'attività",
    "showAll": "Mostra tutti",
    "activitiesShowSame": "Attività: %{activityName}",
    "challengeShowSame": "Sfida: %{challengeName}",
    "chooseTimePeriod": "Scegli un periodo di tempo",
    "youCanFilterOneAtTime": "È possibile selezionare un filtro alla volta",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Argomenti legati alla salute salvati",
            "title": "Successo!"
        },
        "info": {
            "message": "Impossibile salvare"
        },
        "danger": {
            "title": "Errore!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Obiettivi di salute salvati",
            "title": "Successo!"
        },
        "info": {
            "message": "Impossibile salvare"
        },
        "danger": {
            "title": "Errore!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Interessi salvati",
            "title": "Successo!"
        },
        "info": {
            "message": "Impossibile salvare"
        },
        "danger": {
            "title": "Errore!"
        }
    },
    "edit_event": "Modifica evento",
    "leave": "Abbandona",
    "delete_event": "Elimina evento",
    "no_events": "Nessun evento",
    "no_events_placeholder": "Al momento non hai intenzione di partecipare a nessun evento futuro. Perché non decidi di partecipare a uno di essi?",
    "event": "evento",
    "challenge": "Sfida",
    "invited_you": "Ti ha invitato",
    "public": "Pubblico",
    "private": "Privato",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evento eliminato con successo."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Hai abbandonato l'evento"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evento aggiornato con successo."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Evento creato con successo.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "Il contenuto che stai cercando di visualizzare non è attualmente disponibile. Potrebbe essere stato cancellato dall'autore o contrassegnato come inappropriato.",
    "start_time": "Ora di inizio",
    "end_time": "Ora di fine",
    "event_type": "%{eventType} evento",
    "leave_event_modal": {
        "title": "Se abbandoni questo evento",
        "message": "Verrà eliminato"
    },
    "leave_event ": "Sei sicuro di voler abbandonare questo evento?",
    "create_event": "Crea evento",
    "created_by": "Creato da",
    "eventActionToast": {
        "danger": {
            "title": "Errore",
            "message": "Qualcosa è andato storto."
        }
    },
    "continue": "Continua",
    "wantExitTour": "Sei sicuro di voler uscire dal tour?",
    "exitTour": "Esci dal tour",
    "deleveEventPopup": "Sei sicuro di voler eliminare questo evento?",
    "attendeesTitle": "Iscritti",
    "userEvents": "Eventi di %{name}",
    "createEventIndicator": "Creazione di un evento in corso",
    "inviteToEvent": "Invita all'evento",
    "noDescription": "Non c'è una descrizione.",
    "leaderboardIsEmpty": "Questa classifica è vuota o potrebbe essere necessario registrare l'attività nel periodo di tempo selezionato per visualizzarla",
    "notParticipantingInAnyChallenges": "Non stai partecipando a nessuna sfida",
    "buttonLeaveEvent": "Abbandona l'evento",
    "leaveEvent ": "Vuoi abbandonare %{name}?",
    "canceledCreatingChallenge": "La creazione di un %{challengeType} è stata annullata con successo",
    "swipeReadNotification": "Letto",
    "productTour": {
        "initialScreen": {
            "title": "Benvenuto a %{programName}!",
            "body": "Facciamo un breve tour e in pochi istanti conoscerai le nozioni di base."
        },
        "dashboard": {
            "title": "Dashboard",
            "body": "Vedi quanti %{pointsName} hai e i tuoi progressi alla conquista dei livelli. Poi controlla la classifica per vedere come ti sei piazzato."
        },
        "rewards": {
            "title": "Premi",
            "body": "Vedi quanti %{rewardPointName} hai e riscattali nel negozio."
        },
        "goals": {
            "title": "Obiettivi e sfide",
            "body": "Gli obiettivi personali attivi, le sfide con gli altri e i compiti speciali si trovano qui."
        },
        "explore": {
            "title": "Scopri",
            "body": "Trova le sfide con gli altri, unisciti alle community per parlare dei tuoi interessi e scopri un nuovo articolo nella libreria Benessere."
        },
        "me": {
            "title": "Io",
            "body": "Trova il tuo punteggio Benessere, controlla le tue statistiche e modifica il tuo profilo e le tue impostazioni qui."
        },
        "finishScreen": {
            "title": "Sei pronto",
            "body": "Grazie per aver completato il tour.",
            "button": "Cominciamo"
        },
        "skip": {
            "title": "Sei sicuro di voler saltare il tour?",
            "body": "Così facendo il tour terminerà e potrai iniziare subito."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Errore di autenticazione",
            "message": "Non è stato possibile procedere con il riscatto del premio. Si è verificato un errore durante l'autenticazione con il fornitore di premi."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Riscatto non andato a buon fine",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Prima di iniziare",
    "disclamerSectionMessage": "Prima di iniziare un nuovo programma di esercizio fisico o di apportare modifiche allo stile di vita, consulta il tuo operatore sanitario per assicurarti che sia adatto a te.",
    "noEarchedAchievements": "Non hai ancora raggiunto nessun traguardo. Registra un'attività per iniziare.",
    "noInProgressAchievements": "Non hai traguardi in corso.",
    "discardCreatingEventMessage": "Verifica che siano stati inseriti tutti i campi obbligatori",
    "discardCreatingEventTitle": "L'evento non può essere creato",
    "discardEditedEventTitle": "L'evento non può essere modificato",
    "errorEventNameMessage": "Il nome è obbligatorio",
    "errorEventStartDateMessage": "La data di inizio è obbligatoria",
    "errorEventEndDateMessage": "La data di fine è obbligatoria",
    "errorEventDateMessage": "La data di fine non può essere precedente alla data di inizio.",
    "noAccountsToLink": "Non ci sono account disponibili da collegare a %{program_name}.",
    "accountLinkEmailChanged": "Il tuo indirizzo e-mail è stato aggiornato. In futuro, accedi con il tuo account collegato.",
    "accountLinkSuccessful": "Il tuo account è stato collegato con successo.",
    "edit_profile_nan_value": "Il valore deve essere un numero",
    "advancedLogIn": "Accesso avanzato",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Riscatto non andato a buon fine",
            "message": "La sessione d'ordine è scaduta. Riprova a effettuare l'ordine."
        }
    },
    "left": "rimasto",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Sembra che al momento non ci siano eventi disponibili a cui partecipare. Perché non ne crei uno tu?"
        }
    },
    "reachedHighestLevel": "Hai raggiunto il livello più alto!",
    "error": "Errore",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Riscatto del premio",
            "message": "L'ordine è stato effettuato"
        }
    },
    "redeemRewardComplete": "Riscatto completato",
    "trackActivityTitle": {
        "oneUnit": "Registra: 1 %{units} di %{activity} il %{date}",
        "nUnit": "Registra: %{activity} per %{date}"
    },
    "ssoAuthenticationFailure": "Errore di autenticazione",
    "earnEvery": "Guadagna ogni %{frequenza}",
    "earnOnce": "Guadagna una sola volta",
    "goalSettings": {
        "maximumSet": "Attualmente hai impostato un massimo di 3 obiettivi.",
        "learnMore": "Scopri di più sulla definizione degli obiettivi"
    },
    "allowMarketingComms": "Inviami comunicazioni promozionali",
    "allowPartnerMarketingComms": "Inviami comunicazioni promozionali dai partner",
    "noUpcomingAchievements": "Non hai traguardi imminenti.",
    "settingGoalToast": {
        "success": {
            "message": "Il tuo nuovo obiettivo è stato fissato!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Servizio attualmente non disponibile",
            "signin": "Accesso integrato",
            "signup": "Iscrizione integrata"
        }
    },
    "monthName": {
        "january": "Gennaio",
        "february": "Febbraio",
        "march": "Marzo",
        "april": "Aprile",
        "may": "Maggio",
        "june": "Giugno",
        "july": "Luglio",
        "august": "Agosto",
        "september": "Settembre",
        "october": "Ottobre",
        "november": "Novembre",
        "december": "Dicembre"
    },
    "promotedForMe": "In primo piano",
    "appRating": {
        "enjoying": "La nostra applicazione ti piace?",
        "feedback": "Vuoi darci un feedback?",
        "appStore": "Vuoi darci una valutazione nell'App Store?",
        "googlePlay": "Vuoi darci una valutazione su Google Play?",
        "notReally": "Non direi",
        "yes": "Sì!",
        "sure": "Certo",
        "noThanks": "No grazie",
        "notNow": "Non ora"
    },
    "getMobileApp": "Per utilizzare %{programName} sul tuo smartphone, scarica %{appStoreName} dall'App Store o da Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Scarica l'app %{programName}",
        "searchInAppStore": "Cerca %{programName} nello store delle applicazioni del tuo dispositivo",
        "getMobileAppNoName": "Scarica l'app mobile"
    },
    "editorAlert": {
        "discardChanges": "Cancella modifiche",
        "saveAndContinue": "Salva e continua",
        "title": "Modifiche non salvate",
        "text": "Hai apportato delle modifiche che non sono state salvate. Cosa ti piacerebbe fare?"
    },
    "resources": "Risorse",
    "noResources": "Nessuna risorsa disponibile",
    "viewAllResources": "Visualizza tutte le risorse",
    "language": "Lingua",
    "eventStarted": "L'evento è iniziato. La registrazione è chiusa.",
    "Gender": "Sesso",
    "show": "Mostra",
    "hide": "Nascondi",
    "timeoutError": "Ops! Qualcosa sta richiedendo troppo tempo. Riprova più tardi.",
    "SOT": {
        "sample_task": "Esempio di compito"
    },
    "cache": {
        "new_version": "È disponibile una nuova versione!",
        "refresh_browser": "Fai clic qui per aggiornare il tuo browser."
    },
    "welcomeUser": "Benvenuto, %{userFirstName}!",
    "quarter": "trimestre",
    "completionReward": "Premio di completamento",
    "bronzeLevel": "Livello bronzo",
    "deviceAppSyncingOk": "Sincronizzazione dispositivo\/app riuscito\/a",
    "deviceAppSyncingIssue": "Problema di sincronizzazione dispositivo\/app",
    "deviceAppSyncingError": "Errore di sincronizzazione dispositivo\/app",
    "lastSync": "Ultima sincronizzazione",
    "period": "periodo",
    "yourDaySummary": "La tua giornata finora",
    "steps": "Passi",
    "gender_non_binary": "Non binario o non conforme",
    "take_survey": "Partecipa al sondaggio",
    "social": "Sociale",
    "finalDay": "Ultimo giorno",
    "leaderboard_position": "Posizione in classifica",
    "signUp": {
        "apple": {
            "disconnectSettings": "Disconnetti %{appName} da \"Password e Sicurezza dell'ID Apple\" nelle Impostazioni del telefono per continuare con l'iscrizione."
        }
    },
    "earnPoints": "Guadagna %{customPoints}. Sali di livello.",
    "getReward": "Ottieni %{rewardName}.",
    "buildHealthyHabits": "Costruisci abitudini sane.",
    "highestLevelIndicator": "Hai raggiunto il livello più alto!",
    "highestLevelIndicatorNew": "Hai completato tutti i livelli!",
    "trackYourActivity": "Per ottenere %{customPoints}, registra la tua attività legata a esercizio fisico e benessere.",
    "levelUpToGetRewarded": "Man mano che sali di livello, verrai premiato con %{rewardName}.",
    "levelUpAndEarn": "I tuoi progressi si azzerano ogni %{period}, così potrai salire di livello e guadagnare ripetutamente.",
    "levelUp": "I progressi si azzerano ogni %{period}, così potrai salire di livello ripetutamente.",
    "goToLibrary": "Vai alla libreria",
    "updateEventIndicator": "Aggiornamento dell'evento in corso",
    "meTour": {
        "healthSurveyDisabled": "Controlla le tue statistiche e modifica il tuo profilo e le tue impostazioni qui."
    },
    "createNewGoal": "Crea un nuovo obiettivo",
    "later": "Più tardi",
    "bonusChallenge": "Sfida bonus",
    "bonusChallengeInfo": {
        "withReward": "Guadagnerai %{amount} bonus %{points} completando almeno l'85% di questo %{challengeType}.",
        "noReward": "Otterrai un bonus se completerai almeno l'85% di questa sfida.",
        "boldText": "%{amount} bonus %{points}",
        "noRewardChallengeType": "Otterrai un bonus completando almeno l'85% di questo %{challengeType}."
    },
    "defaultApp": "La tua app predefinita per la salute",
    "bonusGoal": {
        "additionalInfo": "Se tutte le attività saranno state registrate tramite un'app o un dispositivo connessi, riceverai un bonus doppio di %{points}!",
        "additionalInfoNew": {
            "paragraph2": "%{points} bonus vengono assegnati quando l'obiettivo è stato completato. Non riceverai %{points} bonus per gli obiettivi che avrai abbandonato prima di completarli."
        },
        "boldText": "bonus doppio %{points}!",
        "markTitle": "Obiettivo bonus"
    },
    "notify_me": "Avvisami",
    "bonusChallengeReward": "Premio sfida bonus",
    "forCompletingChallenge": "Per aver completato %{challengeName}",
    "notifications_text": "Le notifiche ti aiutano a rispettare gli obiettivi e a tenere il passo con le conversazioni.",
    "type_here": "Digita qui",
    "bonusEarned": "Bonus guadagnato",
    "youEarnedBonus": "Hai guadagnato questo bonus!",
    "inviteOthersToChallenge": "Invita gli altri a partecipare alla sfida",
    "inviteOthersToYourTeam": "Invita gli altri nella tua squadra",
    "manageTeam": "Gestisci la squadra",
    "ft": "piedi",
    "lbs": "libbre",
    "cm": "cm",
    "kg": "kg",
    "community": "community",
    "chooseActivity": "Scegli attività",
    "Recent": "Recente",
    "noActivities": "Nessuna attività corrispondente",
    "photoChooseText": "Scegli",
    "photoCancelText": "Annulla",
    "signIn": {
        "missingEmail": "Indirizzo e-mail mancante",
        "missingPassword": "Assicurati che venga fornita la password",
        "invalidLogin": "Accesso non valido",
        "accountLocked": "Il tuo account è bloccato. Contatta l'amministratore",
        "accountMayNotExist": "Non abbiamo un account per questo indirizzo e-mail. Registrati per creare un account.",
        "wrongPassword": "Password sbagliata. Riprova o fai clic su Password dimenticata per reimpostarla."
    },
    "deleteGoalBonusPoints": "Se non hai ancora guadagnato il bonus associato, non potrai più farlo.",
    "havent_tracked_goal": "Non hai registrato alcuna attività per questo obiettivo.",
    "trackActivity": {
        "search": "Ricerca attività in corso",
        "text": "Registra attività",
        "done": "Fine",
        "discardChanges": "Vuoi cancellare le modifiche?",
        "discardMessage": "Sei sicuro di voler uscire e cancellare i tuoi progressi?",
        "discard": "Cancella",
        "limitMessage": "Puoi registrare solo fino a sette giorni alla volta.",
        "inputDescription": "Quantità di %{activity} per %{date}",
        "gracePeriod": "Hai %{n} %{text} per registrare eventuali attività mancate"
    },
    "dates": "Date",
    "pickDates": "Scegli altre date",
    "selectDates": "Seleziona date",
    "limitReached": "Hai raggiunto il limite",
    "activity": "Attività",
    "keepUpTheGoodWork": "Continua così, ottimo lavoro!",
    "activityTracked": "Attività registrata",
    "new": "Nuovo",
    "newFeatureTitle": "Registrazione dell'attività più facile e veloce",
    "newFeatureText": "Che tu stia registrando le attività di oggi, quelle passate o di più giorni, siamo convinti che la nuova esperienza ti piacerà.",
    "gotIt": "Capito!",
    "frequencyViewHistory": "Visualizza l'analisi dettagliata %{frequency}",
    "challengeDetails": {
        "trackTheseActivities": "Registra una qualsiasi di queste attività per fare progressi verso questo %{challengeType}."
    },
    "member": "membro",
    "weeklyBreakdown": "Analisi dettagliata settimanale",
    "setGoals": {
        "earnPointsText": {
            "start": "Guadagna",
            "end": "per aver fissato il tuo primo obiettivo!"
        }
    },
    "weeklyGoalEnded": "La settimana si è conclusa il",
    "weekFinished": "Hai terminato una settimana di",
    "restartGoal": {
        "daysLeftToTrack": "Hai ancora %{quantity} %{days} per registrare eventuali progressi dimenticati dalla settimana scorsa.",
        "weekEnded": "Questa settimana è terminata.",
        "timesUp": "Tempo scaduto!",
        "period": {
            "title": "Periodo di riferimento",
            "text": "Da lunedì a domenica, ogni settimana"
        }
    },
    "membersPlural": "Membri",
    "startedADayAgo": "Iniziato 1 giorno fa",
    "goalRestarted": "Hai riavviato questo obiettivo",
    "weeklyGoals": "Obiettivi settimanali",
    "weeklyGoalsDescription": "Gli obiettivi settimanali si rinnovano ogni lunedì, affinché tu possa mantenere una sana abitudine per un lungo periodo di tempo.",
    "challengeEnded": "Questo %{challengeType} è terminato",
    "goalEndedModalTitle": "Tempo scaduto! Il tuo %{challengeType} è terminato!",
    "yourProgress": "I tuoi progressi",
    "earn_withRewards": "Tieni traccia della tua attività salutare per guadagnare (%{pts}) e superare i livelli. Quando sali di livello, riceverai %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Periodo corrente",
    "currentScore": "Punteggio attuale",
    "viewActivityLog": "Visualizza il registro delle attività",
    "balanceHistory": "La cronologia del mio saldo",
    "mymedibank": {
        "underAge": {
            "error": "L'app Vivere meglio è disponibile solo per gli utenti di età pari o superiore ai 18 anni; per ulteriori informazioni, consultare i Termini e le Condizioni di Vivere meglio."
        }
    },
    "enhancedHomePageInfo": "Abbiamo riordinato la Home page! Ora è più facile vedere le sfide e gli obiettivi. È ora di registrare!",
    "levelUpTitle": "Sali di livello",
    "levelUpDescription": "Supera i livelli registrando le attività e completando gli obiettivi e le sfide. Man mano che sali di livello, verrai premiato con %{currency}!",
    "achievementsDescription": "Sblocca questi badge speciali per guadagnare %{currency}. Fai clic su un badge per vedere cosa devi fare.",
    "bonusChallengesDescription": "Partecipa e completa le sfide che prevedono un bonus %{currency}.",
    "earnWithPartners": {
        "title": "Guadagna con i partner",
        "description": "I membri Medibank con copertura ospedaliera o aggiuntiva possono guadagnare punti su acquisti\/attività idonei\/e presso i partner."
    },
    "browseAllPartners": "Dai uno sguardo a tutti i partner",
    "resetsIn": "Si azzera tra %{daysNumber} giorni",
    "thisIsALot": "È tanto!",
    "areYouSure": "Sei sicuro?",
    "trackingALotMessage": {
        "days": "Stai registrando più di 2.000 %{customPoints} in %{daysNum} giorni. È un bel po'!",
        "day": "Stai registrando più di 2.000 %{customPoints} nel giorno 1. È un bel po'!"
    },
    "amSure": "Sono sicuro",
    "activeMinutesAndSleep": {
        "title": "Registrazione del dispositivo per minuti attivi e sonno",
        "description": "Il tuo dispositivo registra i minuti attivi durante l'attività fisica di moderata o elevata intensità - questo è un allenamento di buona qualità! Usi un dispositivo per registrare il tuo sonno? Guadagnerai %{points} anche per questo!"
    },
    "hourShort": "ora",
    "hoursShort": "ore",
    "secondsShort": "secondo",
    "watchToEarn": "Guarda per guadagnare",
    "oneParticipant": "1 partecipante",
    "oneTeam": "1 squadra",
    "numberOfTeams": "%{num} squadre",
    "inviteToYourTeam": "Invito alla tua squadra",
    "inviteToThisChallenge": "Invito a questa sfida",
    "challengeInstructionText": "Registra questa attività per fare progressi ai fini del tuo %{challengeType}.",
    "showLess": "Mostra di meno",
    "startsTomorrow": "Inizia domani",
    "deadlineDayLeft": "giorno rimasto",
    "deadlineDaysLeft": "giorni rimasti",
    "deviceBonus": "bonus dispositivo",
    "appsAndDevices": {
        "header": "App e dispositivi",
        "linked": "Le app e i dispositivi collegati stanno registrando questo %{challengeType}:",
        "noLinked": "Nessuna app o dispositivo pertinenti collegati",
        "link": "Collega il telefono, l'orologio o l'app per registrare automaticamente."
    },
    "yourGoals": "I tuoi obiettivi",
    "yourChallenges": "Le tue sfide",
    "position": "Posizione",
    "team_success": "Successo di squadra",
    "starts_in": "Inizia tra",
    "team_challenge": "Sfida a squadre",
    "your_progress_today": "I tuoi progressi oggi",
    "your_daily_avarage": "La tua media giornaliera è",
    "this_week_progress": "I progressi di questa settimana",
    "this_month_progress": "I progressi di questo mese",
    "overall_progress": "Progressi complessivi",
    "complete": "completo",
    "overallSuccess": "Successo complessivo",
    "teamSuccessAverage": "Media dei successi della squadra",
    "progressDetails": "Dettagli sui progressi",
    "dayStreak": "Sequenza di %{n} giorni!",
    "weekStreak": "Sequenza di %{n} settimane!",
    "dailyProgress": "Progressi giornalieri",
    "participantsSuccessCount": {
        "overall": "%{amount} dei %{total} partecipanti hanno raggiunto l'obiettivo",
        "day": "%{amount} dei %{total} partecipanti hanno raggiunto l'obiettivo oggi",
        "week": "%{amount} dei %{total} partecipanti hanno raggiunto l'obiettivo questa settimana",
        "month": "%{amount} dei %{total} partecipanti hanno raggiunto l'obiettivo questo mese"
    },
    "doubleBonusShort": "Bonus doppio!",
    "doubleBonusLong": "Hai guadagnato un bonus doppio!",
    "recommendedGoalDescription": "Gli obiettivi ti aiutano a tenere traccia dei tuoi progressi e a mantene alta la motivazione!",
    "noParticipation": "Nessuna partecipazione",
    "nothingToShow": "Sembra che non ci sia nulla da mostrare in questo momento",
    "yourTeam": "La tua squadra",
    "no_activity_title": "Nessuna attività",
    "brandSupport": {
        "description": "Abbiamo aggiunto assistenza per la sincronizzazione dell'attività con gli smartwatch Polar e Withings. È ora di muoversi!"
    },
    "no_tracked_activities": "Non hai ancora registrato alcuna attività.",
    "button_leave_community": "Abbandona la community",
    "button_delete_challenge": "Elimina %{challengeType}",
    "button_delete_community": "Elimina community",
    "button_delete_activity": "Elimina attività",
    "library_header_description": "Contenuti originali per educare, coinvolgere e ispirare nel tuo percorso di benessere.",
    "library_searchbar": "Ricerca nella libreria in corso",
    "library_page_header": "Contenuti originali per educare, coinvolgere e ispirare nel tuo percorso di benessere.",
    "onboarding_button_title": "Ho finito",
    "refresh_bar": "Fai clic qui per aggiornare",
    "content": {
        "min_read": "%{readingTime} minuti di lettura"
    },
    "noMembers": "Nessun membro",
    "saved": "Salvato",
    "forYou": "Per te",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} da",
    "youCanEarnThisBadge": "Puoi guadagnare questo badge una volta ogni %{period}",
    "emailPreferences": "Preferenze e-mail",
    "unsubscribeText": "Rinuncia a tutti gli aggiornamenti tramite e-mail",
    "savingText": "Salvataggio in corso",
    "wrongTryLater": "Qualcosa è andato storto. Riprova più tardi.",
    "preferencesSaved": "Preferenze salvate",
    "recommendedForYou": "Consigliato per te",
    "formerMember": {
        "label": "Ex membro"
    },
    "selectionsFromLibrary": "Contenuti dalla nostra libreria scelti solo per te",
    "goalsInfo": {
        "desc1": "per concentrarti sul miglioramento del tuo benessere",
        "desc2": "Hai il numero massimo di obiettivi fissati."
    },
    "createMyOwn": "Crea il mio",
    "isAllSet": "è tutto pronto!",
    "undoLabel": "Annulla",
    "terms": "Termini",
    "placeOrder": "Effettua l'ordine",
    "item": "Articolo",
    "redeemFor": "Riscatta per",
    "confirmYourOrder": "Conferma l'ordine",
    "orderComplete": "Ordine completo",
    "redeemedFor": "Riscattato per",
    "orderDetails": "Dettagli dell'ordine",
    "bonusGoalReward": "Premio obiettivo bonus",
    "orderSummary": "Riepilogo dell'ordine",
    "logoutSSO": {
        "title": "Sei uscito da %{programName}.",
        "description": "A presto!",
        "signinAgain": "Fai clic qui per accedere nuovamente"
    },
    "nothing_to_show": "Nulla da mostrare al momento",
    "no_saved_content": "Non hai contenuti salvati",
    "restarts_every_week": "Riparte ogni settimana",
    "myGoals": "I miei obiettivi",
    "goalGallery": "Galleria degli obiettivi",
    "share_smth": "Condividi qualcosa...",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Il nostro obiettivo di passi è appena diventato più smart!",
            "description": "Le tue settimane sono sempre diverse e ora lo sono anche i tuoi obiettivi! \n Con la Modalità Smart, il tuo obiettivo di passi si regolerà in base alla tua attività reale.\n È impostata tenendo conto dei tuoi traguardi e del tuo benessere.",
            "action": "Guarda qui!"
        },
        "mePage": {
            "title": "Il nuovo Io",
            "description": "Abbiamo ridisegnato la sezione Io per rendere più semplice la ricerca delle cose che ti interessano: dai un'occhiata!",
            "letsSeeBtn": "Vediamo!",
            "llaterBtn": "Forse più tardi"
        },
        "bellEAP": {
            "title": "Benvenuto alla nostra piattaforma online del Programma di assistenza ai dipendenti e alle famiglie!",
            "description": "Scopri gli strumenti e i servizi a sostegno del benessere e delle sfide della vita disponibili per te e per i tuoi familiari idonei",
            "button": "Connettiti ora o visita la pagina Collegamenti rapidi in qualsiasi momento"
        },
        "quickActivityLogView": {
            "title": " Un modo più rapido per visualizzare le tue attività recenti",
            "description": "Ora puoi fare clic sulla barra di avanzamento per visualizzare il registro delle attività."
        }
    },
    "goalSmartMode": {
        "title": "Modalità Smart",
        "description": "Ricevi obiettivi settimanali personalizzati in base al tuo livello di attività recente.",
        "status": "La Modalità Smart è %{status} per questo obiettivo.",
        "infoModal": {
            "descriptionOne": "Quando la Modalità Smart è attivata, l'obiettivo per questo obiettivo cambierà di settimana in settimana in base al tuo livello di attività recente.",
            "descriptionTwo": "Ti sfideremo quel che basta per prepararti al successo.",
            "instructions": ""
        },
        "settings": {
            "switch": "Attiva la Modalità Smart per il mio obiettivo di passi",
            "description": "Quando la Modalità Smart è attivata, all'inizio di ogni settimana riceverai un nuovo obiettivo di passi."
        },
        "enableSmartMode": "Abilita la Modalità Smart",
        "settingsModal": {
            "descriptionTurnOn": "Il tuo obiettivo di passi cambierà ogni settimana in base alla tua attività",
            "descriptionTurnOff": "Il tuo obiettivo di passi non sarà più personalizzato ogni settimana"
        }
    },
    "On": "Il",
    "Off": "Disattivata",
    "top_posts": "Post principali",
    "most_recent": "Il più recente",
    "browseByTopic": "Sfoglia per argomento",
    "video": "Video",
    "enable": "Abilita",
    "turnOff": "Spegni",
    "new_post": "Nuovo post",
    "new_post_in": "Nuovo post in",
    "dailyTarget": "Obiettivo giornaliero",
    "dailyTargetForWeek": "Obiettivo giornaliero della settimana",
    "showMyActivityLog": "Mostra il mio registro delle attività",
    "usersReacted": {
        "oneOther": "%{userName} e 1 altro",
        "multipleOthers": "%{userName} e %{count} altri"
    },
    "reactionsModal": {
        "title": "Altri modi per festeggiare",
        "description": "Fai il tifo per i tuoi colleghi con le nuove reazioni ai post sui social!"
    },
    "account": "Account",
    "myWellbeingProfile": "Il mio profilo Benessere",
    "physicalDetailsDescription": "Queste informazioni sono necessarie per calcolare il punteggio Benessere",
    "wellbeingInterests": "Interessi Benessere",
    "myWellbeingInterests": "I miei interessi Benessere",
    "preferredNameOptional": "Nome preferito (campo facoltativo)",
    "basicPhysicalDetails": "Dettagli fisici di base",
    "notRegistered": {
        "infoModal": {
            "title": "Non riusciamo a trovarti",
            "notInSystem": "non è nel nostro sistema.",
            "correctEmail": "Assicurati di utilizzare l'account corretto (di solito un indirizzo e-mail aziendale) e controlla che non ci siano errori di battitura.",
            "emailHelp": "Per ulteriore assistenza, invia un'e-mail al nostro team di supporto all'indirizzo"
        }
    },
    "dontHaveAccount": "Non hai un account?",
    "wasThisHelpful": "È stato utile?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Quanto è utile questa pagina e il tuo punteggio Benessere?",
        "commentSectionText": "Come potremmo migliorarli?",
        "commentSectionPlaceholder": "Aggiungi un commento",
        "thankYouModal": "Grazie per il tuo feedback!"
    },
    "number_connected": "%{numDevices} connesso",
    "searchPlaceHolder": "Cerca",
    "noTeamsFound": "Nessuna squadra trovata",
    "join_a_challenge": "Partecipa a una sfida",
    "me_page_titles": {
        "goal": {
            "singular": "obiettivo",
            "plural": "obiettivi"
        },
        "challenge": {
            "singular": "sfida",
            "plural": "sfide"
        }
    },
    "seeMoreText": "... vedi di più",
    "adjust_entry": "Rettifica i dati immessi.",
    "overTracking": {
        "title": "Avviso di sovraregistrazione",
        "desc1": {
            "singular": "Questo dato sarà sottoposto a controllo.",
            "plural": "Questi dati saranno sottoposti a controllo."
        },
        "desc2": "L'eccessiva registrazione intenzionale può comportare la sospensione dell'account.",
        "button_edit": "Modifica i miei dati",
        "button_confirm": "Invia così com'è"
    },
    "oneEventAttendee": "1 iscritto",
    "multipleEventAttendees": "%{num} iscritti",
    "to": "a",
    "eventBonusFull": "Partecipando a questo evento guadagnerai %{number} bonus %{points}.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Ti è piaciuto questo articolo?",
    "didYouLikeVideo": "Ti è piaciuto questo video?",
    "tellUsMore": "Dicci di più",
    "thanksForFeedback": "Grazie per il tuo feedback!",
    "challengesSubtitle": "Raggiungi un obiettivo insieme ad altri partecipanti o gioca per vincere!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Vivere meglio",
    "appStoreNameTelus": "Benessere TELUS Health",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Assistenza virtuale Telus Health",
    "virtualCare": "Assistenza virtuale",
    "changePassword": {
        "telus": {
            "info": "La tua password viene gestita attraverso il tuo account %{telusVC}.",
            "button": "Modifica la mia password %{virtualCare}"
        }
    },
    "actions": "azioni",
    "onAndUpcoming": "In corso e imminenti",
    "termsAndPrivacyPolicyNew": "Continuando, accetti la",
    "invitedToTeam": "Invito alla squadra di %{firstName} %{lastName}",
    "decline": "Rifiuta",
    "invitedToChallenge": "Invitato da %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Non hai obiettivi fissati"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Non hai sfide da affrontare",
        "buttonLabel": "Scopri le sfide"
    },
    "menu": "Menu",
    "everyone": "Tutti",
    "confirmEmployeeID": "Conferma ID dipendente",
    "employeeIDNoMatch": "Questi ID non corrispondono ancora",
    "hidePost": "Nascondi i post di %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Utente nascosto",
            "message": "Non vedrai più i post di questo utente."
        }
    },
    "moderateHideUserDescription": "Nascondendo i post di questo utente, si rimuoveranno i contenuti specifici dell'utente dallo stream.",
    "startsInOneDay": "Inizia tra 1 giorno",
    "endsInOneDay": "Termina tra 1 giorno",
    "endsToday": "Termina oggi",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "non è nel nostro sistema. L'hai inserito correttamente?",
            "administrator": "Se sei un nuovo dipendente, è possibile che tu non abbia ancora il tuo ID dipendente. Chiedi al tuo amministratore quando riprovare.",
            "emailNotInSystem": "Se sei un nuovo dipendente, è possibile che il tuo indirizzo e-mail non sia stato ancora aggiunto al nostro sistema. Chiedi al tuo amministratore quando riprovare.",
            "eligibleEmail": "non è un indirizzo e-mail idoneo. L'hai inserito correttamente?"
        }
    },
    "oneMember": "1 membro",
    "programCode": {
        "infoModal": {
            "unique": "La tua azienda ha un codice del programma unico che di solito viene fornito tramite e-mail.",
            "support": "Se non riesci a trovare il tuo codice, contatta l'amministratore del tuo programma benessere o invia un'e-mail a support@sproutatwork.com indicando il nome della tua azienda."
        },
        "instructions": "Per iniziare, inserisci il codice del programma fornito dal tuo datore di lavoro"
    },
    "whatsMyProgramCode": "Qual è il mio codice del programma?",
    "enjoyApp": "Goditi la nostra app mobile",
    "programCodeLabel": "Codice del programma",
    "createdByMembersChallenges": "Creato dai membri",
    "invites": "Inviti",
    "recommendedContentTitle": "Scelte dalla libreria per te",
    "amountExchanged": "Importo scambiato",
    "orderStatus": "Stato dell'ordine",
    "orderSuccessfulyyItemForConfirmation": "Ordine riuscito! È stata inviata una conferma all'indirizzo %{email}.",
    "orderedOnDateText": "Ordinato il %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Unisciti alle community",
            "description": "Le community mettono in contatto persone con interessi comuni. Puoi unirti o abbandonare le community in qualsiasi momento."
        },
        "objectives": {
            "title": "I miei obiettivi",
            "description": "Cosa possiamo aiutarti a cominciare o a mantenere? Lo useremo per migliorare i nostri consigli."
        },
        "topics": {
            "title": "I miei argomenti legati al benessere",
            "description": "Vedrai altri suggerimenti e contenuti su queste selezioni."
        }
    },
    "recommendedCardDesc": "Fissa fino a 3 obiettivi per migliorare il tuo benessere",
    "accessibility": {
        "track_activity": "Registra attività",
        "cardbody": "Corpo della scheda",
        "cardcontainer": "Contenitore per schede",
        "cardfooter": "Piè di pagina della scheda",
        "unstartedChallengeHeader": "Sfida non iniziata",
        "activeOrEndedChallengeWrapper": "Copertina della sfida",
        "activeOrEndedChallengeHeader": "Intestazione della sfida",
        "goalHeader": "Intestazione obiettivo",
        "openOptions": "Apri opzioni"
    },
    "teams": {
        "teamInvites": "Inviti di squadra",
        "findTeam": "Trova una squadra",
        "teamFull": "La squadra è al completo"
    },
    "deleteAccountText": "Elimina definitivamente il tuo account Sprout at Work e tutti i suoi dati",
    "deleteAccountButtonTitle": "Elimina il mio account",
    "joinTeamActionSheetText": "Unisciti o crea una squadra per partecipare a questa sfida",
    "frequencyNone": "nessuno",
    "quickLinkTitle": "Collegamenti rapidi",
    "moreTab": "Altro",
    "addedBy": "Aggiunto da %{companyName}",
    "teamsTitle": "Squadre",
    "helpAndSupport": "Aiuto e supporto per l'app",
    "feedbackTitle": "Dai un feedback",
    "feedbackDescription": "Dicci cosa ti piace dell'app e dove possiamo migliorare.",
    "leaveTeamAction": "Abbandona la squadra",
    "teamActions": "Azioni della squadra",
    "leaveTeamLeaveChallenge": "Lasciare questa squadra significa abbandonare la sfida. Devi unirti a una squadra per continuare a partecipare.",
    "familyMembers": "Familiari",
    "familyMembersDescription": "I familiari devono avere più di 16 anni. Avranno pieno accesso e visibilità sull'intera piattaforma.",
    "learnMoreButton": "Scopri di più",
    "thvcSelection": {
        "signUpUsingTelus": "Iscriviti utilizzando il tuo account Assistenza virtuale TELUS Health",
        "loginGetStarted": "Accedi ad Assistenza virtuale per iniziare",
        "haveAccount": "Hai un account Assistenza virtuale?",
        "emailHelp": "Ti serve aiuto? Contatta il nostro team di supporto all'indirizzo",
        "yes": "Sì",
        "signMeUp": "No, iscrivimi"
    },
    "inviteFamilyMember": {
        "label": "Invita un familiare",
        "btn": "Invia invito",
        "email": "Indirizzo e-mail*",
        "firstName": "Nome di battesimo*",
        "lastName": "Cognome*",
        "approval": "Confermo di avere l'autorizzazione a invitare questo familiare a %{company}",
        "multiSelect1": "Questo familiare ha superato la maggiore età nella tua regione?",
        "multiSelect2": "Questo familiare ha almeno 16 anni?",
        "confirmTermsPolicy": "Confermo di essere il tutore legale di questa persona. Ritengo che la persona a carico sia sufficientemente matura da utilizzare la piattaforma e acconsento alla sua iscrizione. Spiegherò alla persona a carico la necessità di tenere un comportamento responsabile sulla piattaforma e il modo in cui la piattaforma raccoglie e utilizza i suoi dati.",
        "onTheirBehalf": "per suo conto.",
        "confirm": "Sì, confermo quanto sopra",
        "warning": "Il familiare deve avere almeno 16 anni per iscriversi",
        "errorMsg": "Rivedi gli errori prima di proseguire"
    },
    "deleteFamilyMember": {
        "desc": "L'eliminazione dell'account di un familiare è un'azione permanente.",
        "btn": "Elimina un familiare",
        "confirmation": {
            "title": "Familiare eliminato",
            "desc": "L'account di %{fullName}è stato eliminato"
        },
        "areYouSure": "Sei sicuro di voler eliminare l'account di %{fullName}?"
    },
    "familyInvitationStatus": {
        "active": "Attivo",
        "sent": "Invito inviato"
    },
    "familyInvitationSent": {
        "title": "E-mail di invito inviata",
        "desc": "Invito inviato a %{fullName}"
    },
    "programCodeSignup": "Ti invitiamo a usare il %{programCodeLabel} %{programCode} dopo aver fatto clic su '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Unisciti a questa community per vedere ciò che i membri stanno condividendo",
    "moda": {
        "installApp": {
            "title": "Nota bene: i membri di Moda Health possono accedere a Sprout at Work solo tramite la loro Dashboard membri.",
            "subtitle": "Per usare Sprout at Worksul tuo smartphone:",
            "stepOneA": "1. Installa l'app mobile Sprout at Work.",
            "stepOneB": "Non registrarsi o accedere tramite l'app mobile.",
            "stepTwo": "2. Accedi alla tua Dashboard Membri sul tuo telefono cellulare",
            "stepThree": "3. Vai al programma benessere di Sprout e segui il link: dovrebbe aprirsi l'app mobile Sprout at Work."
        }
    },
    "HRISLocationSelection": {
        "title": "Da quale paese lavori?"
    },
    "visibilitySettings": {
        "title": "Impostazioni di visibilità",
        "desc1": "È accettabile essere visibili agli altri membri dell'app Benessere nella tua azienda?",
        "desc2": "Puoi sempre modificarlo in seguito.",
        "moreTextQ1": "Cosa possono vedere gli altri?",
        "moreTextAnswer1": "Il tuo nome, la foto del profilo e i dettagli di base del profilo (come reparto e sede) possono essere visualizzati dalle persone della tua azienda. Ciò rende l'app più social e divertente.",
        "moreTextQ2": "Dove appaio?",
        "moreTextAnswer2": "Verrai mostrato come partecipante alle sfide, alle comunità e agli eventi a cui partecipi, nelle classifiche e nei risultati di ricerca. Puoi modificarlo in seguito.",
        "moreTextAnswer3": "Non condividiamo né mostriamo le tue informazioni sanitarie personali, come altezza, peso o attività che monitori.",
        "btnAgree": "Va bene mostrarmelo",
        "btnDisagree": "Non lasciare che gli altri membri mi vedano"
    },
    "privacyPolicyReadMore": "Per saperne di più, leggi la nostra Privacy Policy",
    "tellMeMore": "Dimmi di più",
    "helpUsImprove": {
        "title": "Aiutaci a migliorare",
        "desc1": "Utilizziamo strumenti che registrano dati di utilizzo anonimi. Vedere le tendenze in ciò che le persone visualizzano e fanno clic ci aiuta a migliorare l'app.",
        "desc2": "Puoi disattivarlo in qualsiasi momento.",
        "moreTextQ1": "Cosa guardiamo",
        "moreTextAnswer1": "Siamo interessati alle tendenze e alle statistiche generali, quindi non guardiamo i dati a livello individuale.",
        "moreTextQ2": "Non condividiamo i tuoi dati",
        "moreTextAnswer2": "Questi dati sono disponibili solo per le persone che creano questa app per aiutarla a migliorarla. Non lo condividiamo con altre aziende, incluso il tuo datore di lavoro.",
        "moreTextQ3": "I tuoi dati sono anonimi",
        "moreTextAnswer3": "I nostri strumenti non registrano il tuo nome, la posizione esatta o alcuna informazione sanitaria personale.",
        "btnAgree": "Tieni traccia del mio utilizzo in modo anonimo",
        "btnDisagree": "Non acconsento al tracciamento"
    },
    "deleteAccountTextAppName": "Elimina definitivamente il tuo account %{appName} e tutti i suoi dati",
    "anonymousMember": "Membro anonimo",
    "activitiesToTrack": {
        "title": "Attività da monitorare"
    },
    "includedInMembership": "Incluso nel tuo abbonamento",
    "invalidDate": "Data non valida",
    "discardsStreamPost": {
        "discardTitle": "Eliminare il messaggio?",
        "discardChangesTitle": "Eliminare le modifiche?",
        "discardPostText": "Sei sicuro di voler eliminare il tuo post?",
        "discardPostChangesText": "Sei sicuro di voler annullare le modifiche?"
    },
    "trackActivityModalTitle": "Traccia per %{date}",
    "noPosts": "Nessun post da vedere",
    "goalIcon": "Icona obiettivo",
    "resetsOn": "Si reimposta il %{date}",
    "clickForHelp": "Fare clic qui per assistenza",
    "trackActivityInputLabel": "Inserisci %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Articoli trovati",
    "tagState": {
        "active": "Attivo",
        "notActive": "Non attivo"
    },
    "bonusCheckmarkLabel": "Hai ricevuto %{bonusLabel} punti bonus per il completamento",
    "searchBar": {
        "searching": "cercando %{term}",
        "result": "risultati della ricerca"
    },
    "activityProgress": "Avanzamento dell'attività - %{levelName} %{percentFilled}% - Reimposta tra %{daysLeft} giorni",
    "bookmark": {
        "remove": "Rimuovi dagli elementi salvati",
        "save": "Salva questo articolo"
    },
    "bonusMark": {
        "earn": "Guadagna %{qty} %{points}",
        "earned": "Hai guadagnato %{qty} %{points}"
    },
    "tabToTrackActivity": "Tocca per monitorare l'attività",
    "videoElementLabel": "%{title}, durata %{duration}, tocca due volte per riprodurre il video",
    "updatedPoliciesPopup": {
        "title": "Abbiamo aggiornato i nostri termini",
        "details": "Ti invitiamo a leggere le nostre politiche aggiornate di seguito:",
        "disclaimer": "Facendo clic sul pulsante in basso, accetti e riconosci le politiche aggiornate.",
        "agree": "Sono d'accordo"
    },
    "editActivityLog": {
        "canNotEditItem": "Non puoi modificare questa voce",
        "canNotEditItemDescription": "La modifica non è disponibile per le attività sincronizzate da dispositivi o app.",
        "updatedItem": "Attività aggiornata",
        "updatedItemDescription": "Le tue modifiche sono state salvate."
    },
    "login_with_email": "Accedi con email",
    "healthconnect_not_available": "Impossibile connettersi a Health Connect. Nell'app Health Connect, assicurati che le autorizzazioni siano abilitate.",
    "registrationField": {
        "required": {
            "firstName": "Inserisci il tuo nome",
            "lastName": "Inserisci il tuo cognome",
            "email": "Si prega di inserire un indirizzo email valido",
            "password": "Inserisci una password valida"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Per favore inserisci il tuo nome",
        "lastName": "Per favore inserisci il tuo cognome"
    },
    "requiredValidValue": "Inserisci un valore valido per il tuo %{value}",
    "passwordHidden": "Password nascosta, tocca per mostrare la password",
    "passwordShown": "Password mostrata, tocca per nascondere la password",
    "libraryHeaderContent": {
        "category": "",
        "points": "Guadagna %{points} punti."
    },
    "scoreCurrentPeriod": "%{text} va da %{startDate} a %{endDate}",
    "scoreCurrent": "%{testo} equivale a %{punti} punti",
    "abbotResetPasswordModal": {
        "title": "Stai tentando di accedere a un account dell'anno scorso?",
        "text": " Se ti sei iscritto alla sfida dell'anno scorso, quell'account non funzionerà più. Devi iscriverti quest'anno.",
        "goToResetPasswordBtn": "Mi sono iscritto il %{currentYear}",
        "goToSignupBtn": "Non mi sono registrato da %{currentYear}"
    },
    "challengeRegistrationClosed": "Registrazione chiusa - La sfida è iniziata",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit sta per essere rimosso",
            "description": "Passa a Health Connect per continuare a monitorare automaticamente la tua attività.",
            "linkBtn": "Passa a Health Connect"
        },
        "newFeatureModal": {
            "label": "Azione richiesta",
            "title": "Google Fit non supporta più la sincronizzazione delle attività",
            "web": {
                "doNotHaveApp": "Non hai ancora la nostra app?",
                "getAppText": "Scaricalo qui,",
                "dateNotIncludedDescription": "Usa il tuo smartphone per passare a Google's Health Connect.",
                "dateIncludedDescription": "Rimuoveremo l'integrazione con Google Fit il %{date}. Usa il tuo smartphone per passare a Google's Health Connect."
            },
            "mobile": {
                "dateNotIncludedDescription": "Passa a Health Connect per continuare a monitorare automaticamente la tua attività.",
                "dateIncludedDescription": "Rimuoveremo l'integrazione con Google Fit il %{date}. Passa a Health Connect per continuare a monitorare automaticamente la tua attività.",
                "buttonLabel": "Passa a Health Connect"
            }
        }
    }
};